var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileOpAvontuurMetAeroEnSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 560,
    height: 360,
    viewBox: "0 0 560 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dfe9f0;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #85a34c;\n      }\n\n      .cls-7 {\n        fill: #661615;\n      }\n\n      .cls-8 {\n        fill: #5b7234;\n      }\n\n      .cls-9 {\n        fill: #bed3e0;\n      }\n\n      .cls-10 {\n        fill: #a7bbc5;\n      }\n\n      .cls-11 {\n        fill: #ffde14;\n      }\n\n      .cls-12 {\n        fill: #e29260;\n      }\n\n      .cls-13 {\n        fill: #f7ae83;\n      }\n\n      .cls-14 {\n        fill: #d94350;\n      }\n\n      .cls-15 {\n        fill: #ef7d00;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-1",
    d: "M18.126,2.385c10.536,3.6,20.715,3.035,32.379,3.6,15.7.761,30.071,3.291,45.874,1.7C109.517,6.363,124.2,3.9,137.518,4.8c11.4.772,10.323,6.395,13.394,13.105-.163-5-.681-9.8,5.709-11.894,6.369-2.087,21.42-1.8,28.4-1.814,7.872-.022,15.768-.1,23.639,0,9.975.124,16.9,2.748,26.328,3.65,3.255.312,10.577-1.132,13.371-.058,4.008,1.54,2.482,5.08,6.5,6.622A5.777,5.777,0,0,1,258.1,8.592c4.425-2.274,3.326.329,6.89-.147C275.818,7,285.057,5.406,296.452,5.4q13.206,0,26.411,0c7.944,0,17.49-1.715,24.908-1.4,13,.554,12.873,10.978,17.065,16.023.009-4.294-3.242-16.639,6.523-17.564,1.422,2.943,1.673,6.287,4.252,8.778C377.026-2,426.639,3.2,439.342,3.615c17.206.564,38.456-2.88,53.519,1.471,3.33.962,9.82,2.1,12.361,2.873,6.456,1.974,5.884,5.762,11.339,8.288-.422-3.782,2.69-10.152,8.183-12.357C528.956,2.2,536,3.513,542.372,3.684a25.957,25.957,0,0,1-1.693,5.828c20.993,1.774,7.752,7.883,9.422,16.478,3.188,16.4,3.191,34.232,1.794,51.1-8.721.622-16.335.337-22.969,4.971,17.865.549,15.747,1.472,17.389,11.469a135.9,135.9,0,0,1,1.149,15.3c.279,5.387,4.2,9.678,2.554,14.923-1.17,3.724-4.046,4.97-3.175,9.14.322,1.54,2.763,3.994,3.338,5.841,2.9,9.307.971,19.515,3.8,29.1,1.671,5.669,6.3,15.76-.8,19.519-3.264,1.73-13.687,1.316-18.037,2.193-5.422,1.094-11.923,2.754-15.553,5.4,7.529,1.622,14.285-1.142,21.77-.406a2.448,2.448,0,0,1,.814.99c-5.881,1-11.052,3.65-15.728,6.075,6.477.441,23.458-2.915,27.562.96,1.991,1.88,1.809,12.442,1.757,15.332-17.674.6-33.093,1.849-49.413,7.307,9.971.5,39.067-7.4,47.089.672,3.5,3.521-1.605,8.172-1.487,11.565.272,7.787,6.9,13.343,4.472,21.5-3.388,11.4-6.911,18.156-3.055,29.323,4.107,11.892,2.631,23.543,2.445,35.441-.146,9.332,5.767,19.891,3.771,28.916-5.984-.829-13.806-2.112-20.078-1.114-6.342,1.009-10.825,3.556-17.668,4.116-8.379.686-17.074-.7-25.458-.874-27.017-.555-66.89,11.422-84.8-5.011-.95,2.374-1.443,5.035-.267,7.2-40.713-1.332-81.367,9.951-119.516-3.971-15.276,8.537-41.767-.127-57.554,5.7-1.839-7.771-10.683-12.655-13.739-19.919.354,5.988,4.188,14.246-3.545,16.361-1.852.506-9.816.446-12.641.742-9.335.98-17.706,2.225-27.248,2.253-8.744.026-18.017.919-26.619.323-12.946-.9-24.47-5.918-37.76-5.718-10.771.161-21.716,4.783-32.323,4.181-6.67-.379-12.134-3.936-19.04-1.784-1.771-2.682-1.51-6.039-3.861-7.911-.418,3.219-1.192,7.184-4.988,9.195-6.522-4.091-12.99,1.918-20.246,1.75-4.374-.1-7.869-3.051-12.206-3.6-4.489-.572-8.844,1.078-13.587.1-.75-5.586,8.478-8.262,5.477-14.312-1.04-2.1-5.366-3.586-7.064-6.1-2.8-4.133-.337-7.272-.081-11.222,1.582-24.489-3.232-49.508.11-74.268,7.6.033,12.943-6.573,15.731-10.311-5.354.081-10.382.781-14.813-1.015,3.725-6.707-.4-13.566-1.131-20.334C4.411,214.645,3.6,206.454,5.7,204.04c2.172-2.5,8.286-2.582,10.478-6.6-4.723.3-9.038.341-12.505-1.622,3.688-2.368.947-3.955,1.868-6.2,1.074-2.613,4.516-4.44,1.771-7.3,6.137-2.995,25.834-6.134,27.656-11.774,1.667-5.16-22.8-6.066-28.455-8.331,1.31-.179,3.523-1.315,5.014-1.556-.936-.617-1.513-1.783-2.673-2.449,4.194-4.808.924-12.2.632-17.355-.689-12.17.828-24.17-1.649-36.251-1.491-7.274-.758-14.385-1.074-21.685C6.459,76,2.937,69.433,2.749,62.559c-.19-6.915,12.554-18.3,6.081-24.447,1.277-.374,2.375-1.2,3.62-1.577C-1.224,29.553,35.1,28.558,41.93,26.03c-11.142-.643-22.711,2.241-33.272-.988C4.441,23.753.171,22.411,0,19.015c-.138-2.8,5.831-1.988,5.121-5.658,2.95-1.469,3.078-3.411.838-5.446C10.61,5.123,12.406,2.484,18.174,0,17.618,1.314,16.646,2.511,18.126,2.385Z",
    transform: "translate(220 823)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    className: "cls-2",
    width: 560,
    height: 360
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    className: "cls-3",
    transform: "translate(-220 -823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(220 823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    className: "cls-1",
    d: "M18.126,2.385c10.536,3.6,20.715,3.035,32.379,3.6,15.7.761,30.071,3.291,45.874,1.7C109.517,6.363,124.2,3.9,137.518,4.8c11.4.772,10.323,6.395,13.394,13.105-.163-5-.681-9.8,5.709-11.894,6.369-2.087,21.42-1.8,28.4-1.814,7.872-.022,15.768-.1,23.639,0,9.975.124,16.9,2.748,26.328,3.65,3.255.312,10.577-1.132,13.371-.058,4.008,1.54,2.482,5.08,6.5,6.622A5.777,5.777,0,0,1,258.1,8.592c4.425-2.274,3.326.329,6.89-.147C275.818,7,285.057,5.406,296.452,5.4q13.206,0,26.411,0c7.944,0,17.49-1.715,24.908-1.4,13,.554,12.873,10.978,17.065,16.023.009-4.294-3.242-16.639,6.523-17.564,1.422,2.943,1.673,6.287,4.252,8.778C377.026-2,426.639,3.2,439.342,3.615c17.206.564,38.456-2.88,53.519,1.471,3.33.962,9.82,2.1,12.361,2.873,6.456,1.974,5.884,5.762,11.339,8.288-.422-3.782,2.69-10.152,8.183-12.357C528.956,2.2,536,3.513,542.372,3.684a25.957,25.957,0,0,1-1.693,5.828c20.993,1.774,7.752,7.883,9.422,16.478,3.188,16.4,3.191,34.232,1.794,51.1-8.721.622-16.335.337-22.969,4.971,17.865.549,15.747,1.472,17.389,11.469a135.9,135.9,0,0,1,1.149,15.3c.279,5.387,4.2,9.678,2.554,14.923-1.17,3.724-4.046,4.97-3.175,9.14.322,1.54,2.763,3.994,3.338,5.841,2.9,9.307.971,19.515,3.8,29.1,1.671,5.669,6.3,15.76-.8,19.519-3.264,1.73-13.687,1.316-18.037,2.193-5.422,1.094-11.923,2.754-15.553,5.4,7.529,1.622,14.285-1.142,21.77-.406a2.448,2.448,0,0,1,.814.99c-5.881,1-11.052,3.65-15.728,6.075,6.477.441,23.458-2.915,27.562.96,1.991,1.88,1.809,12.442,1.757,15.332-17.674.6-33.093,1.849-49.413,7.307,9.971.5,39.067-7.4,47.089.672,3.5,3.521-1.605,8.172-1.487,11.565.272,7.787,6.9,13.343,4.472,21.5-3.388,11.4-6.911,18.156-3.055,29.323,4.107,11.892,2.631,23.543,2.445,35.441-.146,9.332,5.767,19.891,3.771,28.916-5.984-.829-13.806-2.112-20.078-1.114-6.342,1.009-10.825,3.556-17.668,4.116-8.379.686-17.074-.7-25.458-.874-27.017-.555-66.89,11.422-84.8-5.011-.95,2.374-1.443,5.035-.267,7.2-40.713-1.332-81.367,9.951-119.516-3.971-15.276,8.537-41.767-.127-57.554,5.7-1.839-7.771-10.683-12.655-13.739-19.919.354,5.988,4.188,14.246-3.545,16.361-1.852.506-9.816.446-12.641.742-9.335.98-17.706,2.225-27.248,2.253-8.744.026-18.017.919-26.619.323-12.946-.9-24.47-5.918-37.76-5.718-10.771.161-21.716,4.783-32.323,4.181-6.67-.379-12.134-3.936-19.04-1.784-1.771-2.682-1.51-6.039-3.861-7.911-.418,3.219-1.192,7.184-4.988,9.195-6.522-4.091-12.99,1.918-20.246,1.75-4.374-.1-7.869-3.051-12.206-3.6-4.489-.572-8.844,1.078-13.587.1-.75-5.586,8.478-8.262,5.477-14.312-1.04-2.1-5.366-3.586-7.064-6.1-2.8-4.133-.337-7.272-.081-11.222,1.582-24.489-3.232-49.508.11-74.268,7.6.033,12.943-6.573,15.731-10.311-5.354.081-10.382.781-14.813-1.015,3.725-6.707-.4-13.566-1.131-20.334C4.411,214.645,3.6,206.454,5.7,204.04c2.172-2.5,8.286-2.582,10.478-6.6-4.723.3-9.038.341-12.505-1.622,3.688-2.368.947-3.955,1.868-6.2,1.074-2.613,4.516-4.44,1.771-7.3,6.137-2.995,25.834-6.134,27.656-11.774,1.667-5.16-22.8-6.066-28.455-8.331,1.31-.179,3.523-1.315,5.014-1.556-.936-.617-1.513-1.783-2.673-2.449,4.194-4.808.924-12.2.632-17.355-.689-12.17.828-24.17-1.649-36.251-1.491-7.274-.758-14.385-1.074-21.685C6.459,76,2.937,69.433,2.749,62.559c-.19-6.915,12.554-18.3,6.081-24.447,1.277-.374,2.375-1.2,3.62-1.577C-1.224,29.553,35.1,28.558,41.93,26.03c-11.142-.643-22.711,2.241-33.272-.988C4.441,23.753.171,22.411,0,19.015c-.138-2.8,5.831-1.988,5.121-5.658,2.95-1.469,3.078-3.411.838-5.446C10.61,5.123,12.406,2.484,18.174,0,17.618,1.314,16.646,2.511,18.126,2.385Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(4.92 -43.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(91.354 114.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    className: "cls-5",
    d: "M453.273,166.556a21.175,21.175,0,0,0-15.384-7.689,7.24,7.24,0,0,0-1.1.037,5.7,5.7,0,0,0,.988-2.833,7.191,7.191,0,0,0-3.112-6.38,30.823,30.823,0,0,0-3.567-6.743,12.529,12.529,0,0,0,3.676-8c.579-8.458-5.268-14.575-14.555-15.141q-7.745-.472-15.491-.894a6.047,6.047,0,0,1-2.234-.121q-5.24-.28-10.479-.538a6.138,6.138,0,0,0-3.684,1,6.137,6.137,0,0,0-3.572-1.342q-6.473-.3-12.945-.561a5.852,5.852,0,0,1-2.012-.081q-5.243-.207-10.484-.393a6.13,6.13,0,0,0-3.669,1.048,6.126,6.126,0,0,0-3.591-1.293q-6.474-.209-12.95-.383a5.693,5.693,0,0,1-1.565-.042q-13.356-.349-26.712-.55c-.188,0-.375.006-.558.019-.184-.019-.37-.033-.559-.036q-5.244-.076-10.488-.13a6.064,6.064,0,0,0-5.1,2.643l-.183-.252a6.083,6.083,0,0,0-4.888-2.472q-5.6-.034-11.207-.039a6.063,6.063,0,0,0-5.009,2.585,22.8,22.8,0,0,0-12.069-3.193c-1.656.009-6.048,1.286-9.472,2.668a6.087,6.087,0,0,0-4.508-1.894q-5.244.063-10.488.147a6.1,6.1,0,0,0-4.4,1.956,6.1,6.1,0,0,0-4.471-1.8q-6.365.129-12.729.288a6.1,6.1,0,0,0-4.359,1.976,6.058,6.058,0,0,0-5.16-2.582,6.226,6.226,0,0,0-.885.09q-3.014.521-6.024,1.052a5.965,5.965,0,0,0-4.694,4.056q-3.761,12.083-7.437,24.179a8.044,8.044,0,0,0-4.7,7.373,5.732,5.732,0,0,0,1.282,3.382q-6.188.244-12.375.52a5.714,5.714,0,0,0,.993-3.478,7.068,7.068,0,0,0-2.438-5.022c0-.1-.008-.19-.013-.285a15.36,15.36,0,0,0,13.475-15.774c-.272-7.166-6.041-14.226-16.537-13.748q-7.524.345-15.048.737a6.044,6.044,0,0,0-5.1,3.269,22.636,22.636,0,0,0-12.889-2.913c-2.528.145-11.294,3.61-13.284,5.486a21.218,21.218,0,0,0-.227,31.045,20.224,20.224,0,0,0,4.568,3.222l-2.131.138a5.907,5.907,0,0,0-5.385,4.486q-.282,1.18-.563,2.362l-1.032-2.428a5.915,5.915,0,0,0-5.876-3.543q-6.008.427-12.016.884a5.868,5.868,0,0,0-5.463,6.264,7.16,7.16,0,0,0,2.592,4.936q.716,9.212,1.433,18.423a7.709,7.709,0,0,0-1.732,5.769,5.843,5.843,0,0,0,6.274,5.355q3.243-.248,6.487-.485a5.833,5.833,0,0,0,2.775-.937,5.847,5.847,0,0,0,5.241,1.119q2.155-.584,4.309-1.164a5.854,5.854,0,0,0,1.7-.766,5.831,5.831,0,0,0,2.929.567q6.274-.413,12.548-.793a5.831,5.831,0,0,0,1.287-.227,5.85,5.85,0,0,0,1.3.072q11.641-.691,23.288-1.263a5.835,5.835,0,0,0,4.419-2.375,5.838,5.838,0,0,0,4.628,1.948q6.28-.283,12.559-.534a5.839,5.839,0,0,0,5.61-6.044,7.125,7.125,0,0,0-2.366-5.041l-.38-9.939a10.079,10.079,0,0,0,3.01.353,5.885,5.885,0,0,0,5.583-4.779,11.886,11.886,0,0,0,1.769,4.99,5.747,5.747,0,0,0-1.083,3.57l.269,7.831a5.823,5.823,0,0,0,1.288,3.454c1.88,2.325,7.886,5.485,15.379,5.281a15.782,15.782,0,0,0,12.477-6.34,20.777,20.777,0,0,0,14.982,5.758c1.9-.033,9.083-2.3,12.12-4.026a5.842,5.842,0,0,0,5.243,3.178q11.655-.091,23.315-.061a5.842,5.842,0,0,0,5.856-5.643q.076-2.4.155-4.794c.655,5.59,5.406,11.125,15.037,11.233a20.9,20.9,0,0,0,9.757-2.237,15.894,15.894,0,0,0,8.524,2.52,5.847,5.847,0,0,0,4.542-2.027q2.106-2.441,4.221-4.878c-.024.205-.06.408-.065.616a5.839,5.839,0,0,0,5.695,5.964q5.069.131,10.137.283a5.834,5.834,0,0,0,4.349-1.746,5.836,5.836,0,0,0,4.228,2.021q6.151.207,12.3.449c.146.006.288,0,.432,0,.142.017.285.033.43.039q11.651.46,23.3,1.039a5.791,5.791,0,0,1,3.286.167q6.278.32,12.554.676a5.834,5.834,0,0,0,2.768-.52,5.845,5.845,0,0,0,2.686.836q5.237.308,10.474.641a5.826,5.826,0,0,0,4.125-1.356,21.555,21.555,0,0,0,9.541,2.916c2.129.142,11.115-1.949,13.382-3.5a21.661,21.661,0,0,0,9.284-16.195A20.822,20.822,0,0,0,453.273,166.556Zm-35.3-6.571c.037-.016.075-.026.111-.043a6.032,6.032,0,0,0,2.73.847q3.233.2,6.467.412a13.531,13.531,0,0,0-3.051,1.409,23.419,23.419,0,0,0-1.854,1.521A13.051,13.051,0,0,0,417.971,159.986Zm-29.933-30.318a8.226,8.226,0,0,0,.9.737q-.285,5.919-.569,11.839a1.619,1.619,0,0,1-.509,1.054,1.6,1.6,0,0,1-.419-1.1Q387.741,135.934,388.038,129.668ZM355.5,128.342a8.214,8.214,0,0,0,.91.724L356,140.911a1.616,1.616,0,0,1-.494,1.061,1.593,1.593,0,0,1-.434-1.093Zm-44.415,22.366q.113-7.318.224-14.637a10.525,10.525,0,0,0,2.267-.4q-.082,4.974-.162,9.946a7.071,7.071,0,0,0-2.292,5.09,5.717,5.717,0,0,0,1.083,3.433c-.652-.158-1.335-.293-2.049-.4A5.715,5.715,0,0,0,311.083,150.708Zm-59.231,6.263a21.946,21.946,0,0,0-12.3-3.483,5.807,5.807,0,0,0,.41-.93q1.058-3.231,2.124-6.461a20.814,20.814,0,0,0,3.234,4.442,20.445,20.445,0,0,0,7.646,5.01A5.845,5.845,0,0,0,251.852,156.971Zm-106.116.458c.651-.318,1.218-.629,1.7-.925a5.917,5.917,0,0,0,.561.8Zm20.682,23.133a5.824,5.824,0,0,0-1.426-1.609l-1.272-.979a5.861,5.861,0,0,0-2.219-1.059c.06-.018.119-.049.18-.068a5.955,5.955,0,0,0,1.572.138,10.031,10.031,0,0,0,2.969-.607Zm28.48-12.836q-.114-3.329-.229-6.658a5.706,5.706,0,0,0-1.262-3.388q2.242-.079,4.485-.153a5.981,5.981,0,0,0,4.3-2.019,5.872,5.872,0,0,0,.672.571A14.48,14.48,0,0,0,194.9,167.725Zm27.049-11.58a5.956,5.956,0,0,0,1.468-1.181,5.943,5.943,0,0,0,3.956,2.53,8.108,8.108,0,0,0-1.345.878c-.266.234-.522.473-.775.717a5.69,5.69,0,0,0-.451-.671A9.271,9.271,0,0,0,221.947,156.145Zm69.612,16.431a14.632,14.632,0,0,0-4.8,8.317q.02-.638.042-1.279a5.793,5.793,0,0,0-2.2-4.732l-1.264-1a5.921,5.921,0,0,0-6.222-.69l-1.443.691a5.866,5.866,0,0,0-2.132,1.737q0-5.415-.007-10.828a6.989,6.989,0,0,0,2.143-5.426,5.839,5.839,0,0,0-4.484-5.32c.5-.205.973-.409,1.4-.611a5.956,5.956,0,0,0,5.076,2.822q5.155.006,10.309.034a5.937,5.937,0,0,0,5.641-3.9l1.021,1.458a5.9,5.9,0,0,0,1.984,1.776,11.739,11.739,0,0,0-3.406,1.771,10.783,10.783,0,0,0-3.888,8.178A12.514,12.514,0,0,0,291.559,172.576Zm42.178,9.886a8.358,8.358,0,0,0-2.372,1.5,5.785,5.785,0,0,0-1.963-4.624l-.832-.731a7.648,7.648,0,0,0,2.269-5.266,5.847,5.847,0,0,0-5.759-5.955l-2.245-.047a10.258,10.258,0,0,0,.152-1.577,10.742,10.742,0,0,0-4.953-9.112q5.849.108,11.7.243a5.891,5.891,0,0,0,6.077-5.676,7.07,7.07,0,0,0-2.08-5.18q.124-4.972.247-9.945c.272.092.551.169.833.24l-.1,3.945a16.664,16.664,0,0,0,5.96,13.134,20.015,20.015,0,0,0,3.986,2.686,5.8,5.8,0,0,0-2.108,2.7Q338.1,170.621,333.737,182.462ZM361.7,161.29a7.208,7.208,0,0,0,2,5.2q-.064,1.68-.128,3.358-1.94-5.773-3.9-11.543a5.814,5.814,0,0,0-.6-1.211,19.988,19.988,0,0,0,5.4-2.9,17.754,17.754,0,0,0,4.385-4.779,17.746,17.746,0,0,0,3.991,5.113,19.545,19.545,0,0,0,1.856,1.448q-3.436-.146-6.872-.281A5.864,5.864,0,0,0,361.7,161.29Zm32.97-4.366a19.851,19.851,0,0,0,2-1.279c.133-.1.261-.2.391-.3a5.743,5.743,0,0,0,.788,1.735l-2.951-.153C394.826,156.92,394.751,156.925,394.674,156.924Z",
    transform: "translate(-91.354 -114.784)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(97.652 120.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    className: "cls-6",
    d: "M119.661,141.823a15.6,15.6,0,0,1,5-12.527c.838-.8,8.21-3.784,9.418-3.855,10.225-.627,16.07,6.482,16.48,14.086a15.754,15.754,0,0,1-5.23,12.649c-.886.784-8.271,3.652-9.369,3.724A14.956,14.956,0,0,1,119.661,141.823ZM139.026,152.5c1.741-1.926,2.234-7.071,1.934-12.17a29.021,29.021,0,0,0-1.75-9.219c-.409-.887-3.8-3.674-5-3.6a16.846,16.846,0,0,0-3.221,1.416c-1.672,1.841-2.108,6.162-1.81,10.784a34.416,34.416,0,0,0,2.141,10.577c.363.8,3.288,3.7,4.52,3.621A12.831,12.831,0,0,0,139.026,152.5Z",
    transform: "translate(-98.391 -121.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    className: "cls-6",
    d: "M178.133,132.424c.2,4.672-3.184,9.621-9.818,9.934l-1.637.079-.936-1,.836-1.08c2.435-.118,3.277-3.969,3.106-7.645a14.947,14.947,0,0,0-.945-4.939,9.192,9.192,0,0,0-2.609-1.349l-2.452.119,1.245,25.293,1.033.339a1.65,1.65,0,0,1,1.259,1.369q-6.388.308-12.773.652a1.657,1.657,0,0,1,1.113-1.49l.993-.443L155.2,126.722l-1.09-.332a1.678,1.678,0,0,1-1.237-1.363q7.494-.4,14.989-.76C174.6,123.949,177.948,128.059,178.133,132.424Z",
    transform: "translate(-99.261 -121.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    className: "cls-6",
    d: "M210.307,150.459l.478-.231q-3.943-9.5-7.948-18.981l-.934.03q-1.61,5.186-3.2,10.372,3.016-.536,6.036-1.066l1.478,1.858-1.276,1.687q-3.418-.3-6.838-.594-.954,3.108-1.9,6.217l2.312.438a2.342,2.342,0,0,1,1.922,1.97q-5.157.175-10.311.374a2.3,2.3,0,0,1,1.774-2.061l1.793-.5q4.115-13.557,8.338-27.1,3-.532,6-1.056,5.922,14.069,11.71,28.166l.711.2c.356.121,1.2.49,1.225,1.355q-6.258.155-12.516.344C209.133,151.013,209.828,150.688,210.307,150.459Z",
    transform: "translate(-100.236 -121.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    className: "cls-6",
    d: "M220.209,123.965l-.721-.2c-.357-.12-1.217-.488-1.24-1.353q6.34-.167,12.678-.3c.019.866-.689,1.183-1.176,1.41l-.486.227q3.908,9.527,7.755,19.069l.929-.017q3.024-9.166,6.1-18.325l-2.372-.527a2.4,2.4,0,0,1-1.908-2q5.224-.088,10.447-.152a2.31,2.31,0,0,1-1.849,2.015l-1.823.458q-4.474,13.459-8.841,26.937-2.967.486-5.932.981Q226.057,138.063,220.209,123.965Z",
    transform: "translate(-100.971 -121.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    className: "cls-6",
    d: "M249.66,136.557a15.6,15.6,0,0,1,5.686-12.23c.881-.749,8.4-3.323,9.613-3.327,10.237-.059,15.682,7.362,15.667,14.977a15.748,15.748,0,0,1-5.921,12.34c-.928.734-8.457,3.188-9.557,3.2A14.951,14.951,0,0,1,249.66,136.557ZM268.394,148.3c1.845-1.827,2.622-6.937,2.605-12.044a29.014,29.014,0,0,0-1.237-9.3c-.359-.908-3.583-3.879-4.79-3.871a16.9,16.9,0,0,0-3.293,1.235c-1.771,1.745-2.446,6.037-2.405,10.668a34.462,34.462,0,0,0,1.551,10.679c.318.819,3.077,3.872,4.31,3.865A12.81,12.81,0,0,0,268.394,148.3Z",
    transform: "translate(-101.793 -121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    className: "cls-6",
    d: "M314.581,121.881a1.935,1.935,0,0,1-1.814,1.964l-2.326.488q-.178,13.353-.354,26.706-2.8-.038-5.6-.067-7.533-10.839-15.21-21.626-.038,9.5-.077,19,1.015.263,2.028.529c1.015.264,1.759.788,1.754,2q-5.159-.029-10.316-.036a1.925,1.925,0,0,1,1.768-1.988q1.147-.259,2.3-.514.032-11.233.065-22.466-.865-1.214-1.732-2.429l-1.069-.391a1.68,1.68,0,0,1-1.16-1.43q5.582.006,11.163.04,6.819,9.369,13.528,18.78l.221,0q.1-8.072.2-16.144-1.023-.273-2.046-.543c-1.023-.272-1.777-.8-1.765-2.011Q309.358,121.8,314.581,121.881Z",
    transform: "translate(-102.657 -121.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    className: "cls-6",
    d: "M342.945,131.255a6.192,6.192,0,0,1-4.684-3.066q-1.153-2-2.31-4l-1.873-.045q-.3,12.745-.589,25.489l1.005.413a1.649,1.649,0,0,1,1.156,1.457q-6.391-.155-12.782-.273a1.65,1.65,0,0,1,1.217-1.405l1.022-.37q.248-12.745.5-25.491l-1.874-.035q-1.242,1.946-2.478,3.894a6.19,6.19,0,0,1-4.811,2.864q.069-4.393.136-8.786,13.306.207,26.607.567Q343.064,126.863,342.945,131.255Z",
    transform: "translate(-103.54 -121.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    className: "cls-6",
    d: "M376.075,123.583c-.05,1.21-.831,1.7-1.866,1.917l-1.756.363q-.314,7.938-.627,15.874c-.294,7.264-7.466,11.272-12.7,11.1s-12.117-4.67-11.915-11.937l.473-16.485-1.06-.42a1.677,1.677,0,0,1-1.12-1.46q6.449.178,12.9.394c.019.779-.756,1.23-1.208,1.389l-1.038.355-.535,16.484c-.14,4.455,3.87,7.445,6.162,7.527,2.337.082,6.505-2.621,6.677-7.075l.6-15.875-1.723-.5c-1.015-.3-1.756-.844-1.711-2.056Q370.853,123.369,376.075,123.583Z",
    transform: "translate(-104.3 -121.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    className: "cls-6",
    d: "M409.512,125.182c-.068,1.21-.85,1.687-1.892,1.89l-1.761.338-.853,15.863c-.4,7.26-7.627,11.165-12.86,10.916s-12.049-4.841-11.745-12.1q.352-8.239.707-16.476l-1.055-.435a1.681,1.681,0,0,1-1.1-1.476q6.448.272,12.894.577c.008.78-.775,1.22-1.226,1.372l-1.044.341-.768,16.474c-.206,4.452,3.766,7.5,6.055,7.613,2.339.115,6.542-2.528,6.778-6.98l.83-15.864-1.716-.523c-1.012-.313-1.742-.869-1.682-2.079Q404.293,124.893,409.512,125.182Z",
    transform: "translate(-105.175 -121.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    className: "cls-6",
    d: "M439.9,156.336q-5.324-.367-10.651-.71c-2.457-5.1-1.83-13-4.751-13.182l-.821-1.092.95-.983.488.031c2.037.127,3.118-2.189,3.337-5.646.187-2.937-.048-4.166-.4-4.927A9.914,9.914,0,0,0,425.6,128.2l-2.451-.151-1.54,25.276.989.451a1.651,1.651,0,0,1,1.1,1.5q-6.384-.394-12.768-.754a1.649,1.649,0,0,1,1.27-1.359l1.035-.331q.732-12.77,1.462-25.54l-1.047-.45a1.681,1.681,0,0,1-1.08-1.492q7.716.434,15.43.92c5.62.354,9.262,3.466,8.891,8.95-.275,4.06-3.958,6.545-7.909,7.2,3.461,1.479,6.647,5.118,8.879,11.952l.944.455A1.652,1.652,0,0,1,439.9,156.336Z",
    transform: "translate(-106.012 -121.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    className: "cls-6",
    d: "M124.106,171.465l-.569.038q-2.908,12.257-5.736,24.52-2.155.586-4.306,1.176-5.118-12.127-10.33-24.231l-.569.044q.824,10.725,1.647,21.45l1.174.561a1.831,1.831,0,0,1,1.183,1.82q-3.244.247-6.487.5a1.8,1.8,0,0,1,.889-1.981l1.078-.691-1.928-24.814-1.081-.307a1.672,1.672,0,0,1-1.25-1.334q5.979-.472,11.96-.91,3.9,9.067,7.754,18.147l.565-.04q2.216-9.507,4.478-19.009,5.828-.394,11.66-.759a1.61,1.61,0,0,1-1.05,1.5l-.983.453q.809,12.766,1.619,25.53l1.021.326A1.646,1.646,0,0,1,136.1,194.8q-6.274.391-12.547.819a1.646,1.646,0,0,1,1.072-1.5l.97-.456Q124.852,182.563,124.106,171.465Z",
    transform: "translate(-97.821 -122.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    className: "cls-6",
    d: "M162.879,185.16q.076,4.07.152,8.14-11.647.592-23.288,1.3a1.647,1.647,0,0,1,1.082-1.5l.973-.45-1.54-25.535-1.029-.284a1.713,1.713,0,0,1-1.273-1.4q11.464-.7,22.935-1.289.225,4.388.448,8.775a6.151,6.151,0,0,1-4.83-2.7q-1.281-1.817-2.566-3.633-2.673.145-5.345.3.32,5.662.641,11.324,2.026-.115,4.054-.226.359-1.017.72-2.034a2.806,2.806,0,0,1,2.1-1.717q.247,4.626.495,9.251a2.8,2.8,0,0,1-2.261-1.481l-.936-1.944q-2.026.111-4.051.226.313,5.51.624,11.02l2.995.7a5.8,5.8,0,0,0,3.411-1.226q1.886-2.919,3.782-5.834l1.442-.768Z",
    transform: "translate(-98.871 -122.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    className: "cls-6",
    d: "M191.184,171.593a6.078,6.078,0,0,1-4.794-2.758q-1.262-1.919-2.526-3.839l-1.841.076,1.072,25.473,1.013.349a1.647,1.647,0,0,1,1.229,1.378q-6.28.259-12.559.552a1.642,1.642,0,0,1,1.1-1.481l.98-.435-1.166-25.469-1.842.085q-1.091,2.023-2.179,4.046a6.081,6.081,0,0,1-4.535,3.168q-.219-4.388-.436-8.776,13.071-.65,26.147-1.148Q191.017,167.2,191.184,171.593Z",
    transform: "translate(-99.571 -122.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    className: "cls-6",
    d: "M223.4,171.665a6.034,6.034,0,0,1-4.753-2.824q-1.481-2.212-2.969-4.423a4.912,4.912,0,0,0-2.137-1.109c-1.888.054-3.667,2.143-3.591,4.7.118,3.49,15.174,7.545,15.3,13.532a9.8,9.8,0,0,1-9.81,10.341c-5.932.167-10.092-2.422-10.637-3.1q-.127-3.915-.256-7.83a6.089,6.089,0,0,1,4.747,2.794q1.328,2.146,2.65,4.294a14.773,14.773,0,0,0,3.748,2.014c1.645-.046,3.5-2.174,3.411-5.5-.052-2.308-15.038-5.458-15.308-13.145-.212-6.315,4.462-9.851,10.524-10.022,5.884-.165,8.339,1.428,8.881,2.105Q223.3,167.576,223.4,171.665Z",
    transform: "translate(-100.593 -122.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    className: "cls-6",
    d: "M228.163,176.445a15.707,15.707,0,0,1,5.471-12.282c.86-.757,8.231-3.4,9.42-3.415,10.068-.155,15.487,7.215,15.547,14.83a15.857,15.857,0,0,1-5.7,12.4c-.9.742-8.284,3.266-9.363,3.288C234.1,191.412,228.346,184.151,228.163,176.445Zm18.53,11.565c1.8-1.843,2.512-6.961,2.445-12.069a29.506,29.506,0,0,0-1.3-9.289c-.359-.9-3.562-3.846-4.747-3.826a16.3,16.3,0,0,0-3.225,1.265c-1.727,1.762-2.344,6.059-2.261,10.69a35,35,0,0,0,1.629,10.665c.317.816,3.064,3.844,4.274,3.825A12.384,12.384,0,0,0,246.693,188.011Z",
    transform: "translate(-101.231 -122.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    className: "cls-6",
    d: "M285.37,180.874q-.143,4.74-.285,9.479-11.657-.029-23.316.063a1.648,1.648,0,0,1,1.16-1.437l.994-.4q-.089-12.79-.178-25.581l-1.056-.382a1.677,1.677,0,0,1-1.152-1.42q6.344-.05,12.688-.065c.046.779-.7,1.257-1.137,1.432l-1.008.392q.041,12.358.082,24.716l2.952.858a5.8,5.8,0,0,0,3.47-1.043q2.038-3.463,4.088-6.923l1.438-.69Z",
    transform: "translate(-102.104 -122.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    className: "cls-6",
    d: "M330.79,185.143q-2.721,3.142-5.428,6.292c-3.249-.064-5.74-1.235-8.382-4.136-.057-.058-.114-.117-.17-.176l-.885.982c-1.724,1.964-5.378,3.078-8.843,3.038-6.148-.073-9.331-3.165-9.306-6.758.023-3.03,2.31-6.435,7.091-8.679l.921-.422q-1.272-1.357-2.547-2.711c-1.86-1.967-2.673-3.835-2.66-5.524a5.076,5.076,0,0,1,1.876-3.835c.885-.773,7.71-2.556,8.9-2.537,7.292.1,11.1,3.038,11.039,6.413-.047,2.468-2.243,5.194-6.64,7.159l-.572.251q2.384,2.569,4.755,5.144L322.294,177l-1.471-.633a2.1,2.1,0,0,1-1.494-1.931q5.456.093,10.912.215a2,2,0,0,1-1.788,1.909l-2.716.549q-2.007,2.233-4.006,4.469.917.99,1.833,1.983c1.79,1.94,2.818,2.438,3.906,2.46q1.106-.929,2.213-1.857Zm-15.774.048q-3.74-4.04-7.505-8.068l-.527.3c-.263.126-1.543,1.41-1.574,4.267-.044,4.111,2.188,6.17,4.7,6.2a5.537,5.537,0,0,0,3.929-1.59Q314.529,185.746,315.016,185.191ZM308.1,164.834a5.908,5.908,0,0,0,1.616,3.83q1.9,2.016,3.792,4.035l.176-.084c.4-.167.988-1.8,1.016-3.622.046-2.856-.867-6.421-3.368-6.455a17.015,17.015,0,0,0-2.775.786A2.31,2.31,0,0,0,308.1,164.834Z",
    transform: "translate(-103.052 -122.038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    className: "cls-6",
    d: "M360.816,190.38l.484-.2q-3.255-9.732-6.571-19.454l-.918-.029q-1.914,5.07-3.811,10.144,2.995-.342,5.991-.676l1.329,1.951-1.36,1.6q-3.332-.522-6.669-1.034-1.136,3.041-2.268,6.082l2.24.586a2.325,2.325,0,0,1,1.758,2.09q-5.069-.158-10.138-.293a2.28,2.28,0,0,1,1.874-1.941l1.791-.384q4.91-13.264,9.926-26.506,2.977-.337,5.956-.666,4.9,14.421,9.67,28.862l.685.244a1.593,1.593,0,0,1,1.113,1.431q-6.148-.248-12.3-.464C359.627,190.858,360.333,190.579,360.816,190.38Z",
    transform: "translate(-104.179 -122.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    className: "cls-6",
    d: "M397.591,185.22q-.34,4.057-.678,8.113-11.648-.6-23.3-1.074a1.646,1.646,0,0,1,1.228-1.379l1.014-.348,1.069-25.559-.994-.388a1.712,1.712,0,0,1-1.124-1.519q11.474.469,22.944,1.055-.224,4.387-.448,8.775a6.155,6.155,0,0,1-4.53-3.174q-1.09-1.938-2.182-3.876-2.675-.129-5.347-.25-.259,5.665-.516,11.33,2.028.092,4.055.188l.924-1.95a2.8,2.8,0,0,1,2.26-1.494l-.451,9.252a2.8,2.8,0,0,1-2.1-1.7q-.365-1.015-.733-2.029-2.025-.1-4.051-.189l-.5,11.027q1.455.5,2.908,1a5.807,5.807,0,0,0,3.517-.872q2.174-2.713,4.357-5.419l1.513-.616Z",
    transform: "translate(-105.036 -122.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    className: "cls-6",
    d: "M429.392,195.226q-5.235-.345-10.472-.663c-2.428-5.09-1.829-12.99-4.7-13.16l-.81-1.088.932-.987.479.028c2,.118,3.059-2.2,3.269-5.66.176-2.938-.058-4.166-.407-4.925a9.729,9.729,0,0,0-2.409-1.617l-2.41-.14q-.727,12.64-1.454,25.281l.974.447a1.645,1.645,0,0,1,1.087,1.494q-6.277-.367-12.554-.7a1.644,1.644,0,0,1,1.245-1.364l1.018-.336q.688-12.771,1.374-25.545l-1.03-.445a1.675,1.675,0,0,1-1.064-1.487q7.587.4,15.173.853c5.527.329,9.114,3.425,8.763,8.91-.262,4.061-3.874,6.563-7.76,7.239,3.408,1.464,6.545,5.087,8.757,11.911l.928.451A1.642,1.642,0,0,1,429.392,195.226Z",
    transform: "translate(-105.75 -122.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    className: "cls-6",
    d: "M429.784,180.768a15.7,15.7,0,0,1,6.526-11.757c.921-.68,8.5-2.668,9.687-2.579,10.049.726,14.808,8.542,14.2,16.132a15.855,15.855,0,0,1-6.768,11.85c-.967.66-8.543,2.53-9.622,2.457C434.4,196.2,429.293,188.46,429.784,180.768Zm17.46,13.14c1.951-1.68,3.111-6.715,3.491-11.809a29.509,29.509,0,0,0-.489-9.368c-.281-.933-3.215-4.142-4.4-4.226a16.4,16.4,0,0,0-3.326.979c-1.873,1.6-2.867,5.831-3.187,10.451a35.03,35.03,0,0,0,.691,10.766c.247.841,2.717,4.1,3.927,4.184A12.4,12.4,0,0,0,447.244,193.908Z",
    transform: "translate(-106.504 -122.188)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(-20.455 -24.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    className: "cls-5",
    d: "M350.8,376c-5.847-20.094-21.919-37.991-43.179-48.193a116.238,116.238,0,0,0-2.784-13.332c-.943-3.537-1.934-6.692-2.96-9.424l3.288-1.137-.934-3.137c-.2-.681-.429-1.326-.694-2.035l-.228-.59-1.294-3.165-.19.065a23.15,23.15,0,0,0-12.053-10.448c-.093-.228-.193-.451-.3-.671l-.318-.665a40.218,40.218,0,0,0-2.979-5.471c-1.888-2.743-1.69-6.2-1.461-10.2l.07-1.22a67.266,67.266,0,0,0,.087-9.942c-.694-7.319-2.347-15.6-9.35-21.507-3.168-2.673-5.657-3.813-8.323-3.813-.242,0-.481.011-.725.029a17.02,17.02,0,0,0-11.367-3.816,34.634,34.634,0,0,0-5.72.533,32.31,32.31,0,0,0-15.307,7.1c-7.216,6.089-9.884,15.2-10.854,21.776a52.465,52.465,0,0,0-.471,10.587c.036.651.087,1.315.137,1.987.265,3.518.517,6.84-1.032,9.09-.375.544-.786,1.058-1.2,1.575a21.14,21.14,0,0,0-2.652,3.962,12.164,12.164,0,0,0-.514,1.253,23.039,23.039,0,0,0-10.687,9.869l-.2-.068-1.207,2.97s-.256.661-.331.862c-.236.632-.464,1.276-.666,1.957l-.344,1.156c-.7.632-1.8,1.577-3.037,2.646-1.444,1.245-3.142,2.707-4.8,4.181-.027-.047-.055-.093-.083-.139l.44-.483-7.052-12.466,1.981-4.9a5.109,5.109,0,0,0,.675-1.707l.826-4.243a5.118,5.118,0,0,0-4.042-5.995,5.157,5.157,0,0,0-.977-.094,5.1,5.1,0,0,0-3.39,1.288l-1.583-4.076a5.833,5.833,0,0,0-5.212-3.929,4.6,4.6,0,0,0-1.393.214,5.1,5.1,0,0,0-7.161,1.814,5.118,5.118,0,0,0-3.775,3.846,5.122,5.122,0,0,0-2.484,6.433l5.974,15.328a7.128,7.128,0,0,0,3.457,3.78l2.475,14.361,3.246-.3c.3.581.609,1.2.931,1.827.942,1.85,1.974,3.879,2.951,5.737a8.087,8.087,0,0,0-1.047,3.459c-.373,5.371,4.525,9.94,11.15,10.4.35.025.7.036,1.04.036,6.152,0,11.057-3.753,11.437-8.741a98.209,98.209,0,0,0,17.309-11.173q.942-.736,1.835-1.464a33.918,33.918,0,0,0,4.715,13.575l2.164,23.936H230.6a4.734,4.734,0,0,0-2,.439l-.291.134-6.785-14.7a7.412,7.412,0,1,0-10.277,4.744l6.784,14.7-.292.135a4.784,4.784,0,0,0-2.331,6.338l.217.469a4.79,4.79,0,0,0,3.427,2.683,5.119,5.119,0,0,0,.285,3.571,4.993,4.993,0,0,0,2.962,2.637l5.291,11.2c-.116,2.309-.176,4.664-.176,7.018a99.834,99.834,0,0,0,.752,12.971,15.281,15.281,0,0,0-4.677,11.406c0,5.694,2.749,10.761,6.838,12.9-.051,1.332-.075,2.761-.075,4.312a101.33,101.33,0,0,0,.719,11.9l-.7.224,2.188,21.1q-.453.387-.9.762c-27.744,3.367-31.923,10.819-31.923,14.995,0,12.9,35.748,16.306,54.651,16.306s54.651-3.408,54.651-16.306c0-4.171-4.17-11.616-31.86-14.986l-.9-.77,2.19-21.1-.7-.224a101.328,101.328,0,0,0,.72-11.9c0-1.551-.025-2.98-.076-4.313,4.09-2.136,6.837-7.2,6.837-12.9a15.283,15.283,0,0,0-4.676-11.406,99.713,99.713,0,0,0,.752-12.971v0a90.894,90.894,0,0,0,19.915,2.234h0c18.224,0,35.147-5.652,47.65-15.913a6.882,6.882,0,0,0,1.794-2.291l.589-1.192Zm-95.357,92.71q-.574,0-1.152,0c-.368,0-.733,0-1.1,0l-.245-27.756q.019-.358.036-.715l2.688,2.5Z",
    transform: "translate(0 2.11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(166.065 215.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(142.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    className: "cls-5",
    d: "M340.716,502.132c-9.027,0-54.057-.642-54.057-13.337,0-2.192,0-8.724,27.823-11.927q2.093-21.22,4.131-42.446a29.265,29.265,0,0,1-13.876-3.165,10.135,10.135,0,0,1-2.7-1.626l-1.158-1.025,0-1.548c-.008-6.975-.148-14.18-.283-21.147-.12-6.145-.243-12.5-.272-18.533-.018-1.518-.018-3.053-.018-4.587v-.385l-1.191.7-1.523-3.626c-1.079-2.572-1.907-4.771-2.6-6.921a82.253,82.253,0,0,1-4.246-28.656,68.257,68.257,0,0,1,8.172-29.987,101.352,101.352,0,0,1,7.979-12.428l.552-.756c.6-.835,1.28-1.77,2.053-2.674a24.121,24.121,0,0,1,9.224-9.262l6.717-3.769,4.037-2.272c-3.545-2.636-6.429-6.627-8.6-11.9-3.775-.817-7.033-3.947-8.6-8.43-1.617-4.61-.81-9.068,2.054-11.358a7.811,7.811,0,0,1,.827-.579,18.66,18.66,0,0,1-.446-2.217c-.12-1.018-.652-5.921-.883-9.5a20.141,20.141,0,0,1,2.051-10.394,14.582,14.582,0,0,1,4.216-5.207c4.556-3.393,21.3-7.939,32.171-7.939,4.479,0,7.722.73,9.917,2.231,7.126,4.873,5.425,12.982,2.868,17.989,1.575,2.694,3.5,7.81,2.222,15.582l.051.039c2.863,2.29,3.668,6.749,2.051,11.36-1.554,4.432-4.755,7.54-8.475,8.4a28.446,28.446,0,0,1-6.994,10.767v1.669l10.113,5.679a24.16,24.16,0,0,1,8.486,7.99c.189.154.406.349.664.6.319.31.665.665,1.02,1.08.1.112.163.189.218.258l.088.1.344.474a18.182,18.182,0,0,1,1.127,1.678l.194.312a44.659,44.659,0,0,1,2.326,4.593c.675,1.525,1.327,3.164,1.935,4.863a5.008,5.008,0,0,1,3.673-1.666l.3.011,27.985,1.858a4.515,4.515,0,0,1,3.309,1.793,5.021,5.021,0,0,1,.837,4.1l-3.746,17.186a4.851,4.851,0,0,1,1.179,1.116,5.485,5.485,0,0,1,.9,4.482,6.4,6.4,0,0,1-.359,1.138,5.689,5.689,0,0,1,.205,3.2,6.363,6.363,0,0,1-1.013,2.319,5.861,5.861,0,0,1-.1,1.955,6.289,6.289,0,0,1-1.806,3.234,6.05,6.05,0,0,1-.113.746,5.733,5.733,0,0,1-3.8,4.3l-1.168,5.364a5.271,5.271,0,0,1-5.008,4.253l-.3-.011-2.724-.181a22.512,22.512,0,0,1-2.49,2.089,16.531,16.531,0,0,1-3.409,1.9,13.71,13.71,0,0,1-5.136,1.023c-.154,0-.308,0-.465-.009a12.769,12.769,0,0,1-4.737-1.117c.06,3.994.088,8.331.088,13.439l-.007,4.57c-.023,5.779-.08,11.6-.134,17.457-.067,7-.134,14.244-.147,21.419v2.084l-1.589,1.015c-3.928,2.508-9.211,3.993-16.084,4.506q2.065,21.314,4.152,42.622c26.057,3.275,26.058,9.574,26.058,11.714C394.771,501.49,349.741,502.132,340.716,502.132Zm0-26.672q1.33,0,2.643.014c-.415-15.948-.683-28.685-.856-40.55q-.985.023-1.97.038c-.164,11.83-.427,24.584-.838,40.5Z",
    transform: "translate(-286.659 -215.221)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(7.471 3.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(0 66.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(12.783 196.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    className: "cls-7",
    d: "M321.591,451.011c2.378.128,4.91.276,6.745-.7v-1.557l-7.116-.885Z",
    transform: "translate(-300.889 -440.338)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    className: "cls-7",
    d: "M331.354,448.988c-12.644,3.358-22.042,3.764-27.279,1.828l-.166-1.98,27.24-2.285Z",
    transform: "translate(-303.906 -440.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    className: "cls-7",
    d: "M331.211,448.187c-3.993,2.455-25.058,3.9-27.3,1.536-.11-1.359,2.086-2.828,6.056-4.422.393-.156.8-.312,1.232-.476.3-.112.608-.222.928-.341.415-.149.838-.3,1.276-.446h.007c.3-.1.608-.208.92-.311h.008c.43-.141.875-.282,1.335-.43,1.1-.349,2.256-.7,3.481-1.054C329.771,439.157,331.032,446,331.211,448.187Z",
    transform: "translate(-303.907 -441.456)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(55.172 196.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    className: "cls-7",
    d: "M346.75,451.011c-2.379.128-4.91.276-6.746-.7v-1.557l7.117-.885Z",
    transform: "translate(-340.004 -440.338)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    className: "cls-7",
    d: "M340,448.988c12.645,3.358,22.042,3.764,27.279,1.828l.167-1.98-27.241-2.285Z",
    transform: "translate(-340.004 -440.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    className: "cls-7",
    d: "M340.127,448.187c3.991,2.455,25.058,3.9,27.3,1.536.112-1.359-2.086-2.828-6.055-4.422-.393-.156-.8-.312-1.232-.476-.3-.112-.608-.222-.928-.341-.416-.149-.838-.3-1.276-.446h-.007c-.3-.1-.608-.208-.921-.311H357c-.431-.141-.876-.282-1.335-.43-1.1-.349-2.256-.7-3.481-1.054C341.567,439.157,340.3,446,340.127,448.187Z",
    transform: "translate(-339.983 -441.456)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    className: "cls-6",
    d: "M392.212,329.323a6.468,6.468,0,0,0-.979-.587,6.683,6.683,0,0,0-8.919,3.125l-.031.059s-.133.275-.378.794-.624,1.276-1.1,2.211-1.084,2.056-1.788,3.266a33.566,33.566,0,0,1-2.33,3.488,40.474,40.474,0,0,1-2-5.736c-.646-2.292-1.217-4.742-1.758-7.22s-1.047-5.01-1.544-7.51c-.5-2.515-.972-4.957-1.521-7.48-.557-2.471-1.143-4.852-1.788-7.1-.022-.067-.038-.141-.06-.208-.622-2.167-1.261-4.2-1.929-6.077-.675-1.945-1.38-3.718-2.077-5.29a40.3,40.3,0,0,0-2.093-4.149c-.378-.608-.675-1.12-1.076-1.648-.1-.119-.186-.244-.268-.356l-.126-.17c-.045-.052-.074-.1-.163-.193a12.042,12.042,0,0,0-.831-.883,5.386,5.386,0,0,0-.579-.5c-.1-.074-.17-.127-.237-.179a.163.163,0,0,1-.036-.029c-.1-.067-.156-.1-.156-.1a4.338,4.338,0,0,0-5.313,6.856l.1.089a2.068,2.068,0,0,1,.186.148c.06.053.141.112.23.186.155.112.036.075-.015.06a.375.375,0,0,1-.148-.119.057.057,0,0,1,.014.029l.045.074c.031.053.067.1.1.163.134.179.319.565.526.928a34.246,34.246,0,0,1,1.41,3.273c.5,1.343,1.039,2.931,1.543,4.711.527,1.759,1.017,3.725,1.484,5.8s.883,4.311,1.276,6.611c.356,2.271.7,4.8,1.062,7.331q.278,2.015.579,4.074c.186,1.225.371,2.457.571,3.7.416,2.627.883,5.283,1.469,7.948a48.474,48.474,0,0,0,2.441,8.185,20.678,20.678,0,0,0,1.507,2.952,14.913,14.913,0,0,0,1.136,1.6,11.268,11.268,0,0,0,2.775,2.464,9.439,9.439,0,0,0,4.549,1.4,10.231,10.231,0,0,0,4.185-.764,13.119,13.119,0,0,0,2.686-1.5,20.8,20.8,0,0,0,3.25-2.945c.83-.921,1.536-1.788,2.144-2.613.638-.846,1.187-1.639,1.692-2.389.971-1.469,1.758-2.746,2.374-3.8s1.083-1.885,1.387-2.448.483-.861.483-.861c.052-.1.119-.23.17-.334A6.674,6.674,0,0,0,392.212,329.323Zm-14.336,14.321a.886.886,0,0,1-.134-.148C377.959,343.651,377.95,343.711,377.876,343.644Z",
    transform: "translate(-282.819 -272.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    className: "cls-8",
    d: "M376.171,384.759l-20.683-35.071H317.1l-15.4,35.071v18.858c6.2,5.491,51.393,6.477,74.471,0Z",
    transform: "translate(-291.509 -261.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    className: "cls-9",
    d: "M355.906,281.531l-10.274-6.944c-.3,4.541-2.309,8.4-8.328,9.454-5.34-.9-8.116-5.058-8.572-9.6L318.7,281.531c-6.474,20.513-8.422,43.394-7.934,67.549,8.936,1.765,18.782,13.1,26.535,13.068,7.754.033,17.6-11.3,26.536-13.068C363.36,323.787,361.308,300.51,355.906,281.531Z",
    transform: "translate(-289.94 -274.443)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(20.82 74.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    className: "cls-10",
    d: "M337.295,374.2a65.55,65.55,0,0,1-9.663-.423,17.413,17.413,0,0,1-14.957-13.749A102,102,0,0,1,310.76,338a110.723,110.723,0,0,0,26.535,4.556A110.722,110.722,0,0,0,363.831,338a102,102,0,0,1-1.914,22.022,17.413,17.413,0,0,1-14.957,13.749A65.559,65.559,0,0,1,337.295,374.2Z",
    transform: "translate(-310.751 -338.002)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(4.769 1.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    className: "cls-7",
    d: "M316.311,344.805h-1.5v-5.716l1.5.368Z",
    transform: "translate(-314.811 -339.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    className: "cls-7",
    d: "M350.622,344.805h1.5v-5.716l-1.5.368Z",
    transform: "translate(-308.57 -339.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    className: "cls-7",
    d: "M323.685,346.424h-1.5v-5.716l1.5.213Z",
    transform: "translate(-313.526 -338.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    className: "cls-7",
    d: "M343.248,346.424h1.5v-5.716l-1.5.213Z",
    transform: "translate(-309.855 -338.807)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    className: "cls-10",
    d: "M331.853,460.97c.063-.722-.289-5.164-.27-5.9.87-33.145,1.522-66.211.842-99.363-.153-6.481-9.794-7.346-11.07-.993-.721,3.589-.453,7.6-.641,11.23-.76,14.684-1.726,29.353-3.14,43.988q-2.272,23.5-4.576,46.989c-.011.113-.015.224-.022.336C316.483,459.228,322.258,461.876,331.853,460.97Z",
    transform: "translate(-289.543 -261.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    className: "cls-10",
    d: "M337.8,459.549c-.063-.722.289-5.163.27-5.9-.869-33.145-1.521-66.211-.841-99.363.153-6.481,9.792-7.347,11.069-.994.721,3.589.453,7.6.642,11.231.76,14.682,1.725,29.352,3.14,43.988q2.271,23.494,4.575,46.987c.012.113.015.224.022.337C352.468,458.862,346.315,460.843,337.8,459.549Z",
    transform: "translate(-285.364 -261.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    className: "cls-6",
    d: "M330.385,274.443c-.187,16.432-.144,32.856-.169,48.714-.068,38.575-.507,73.753-5.45,97.18-9.428.567-15.868.939-22.981-3.605-.018-13.221-.5-26.91-.556-39.693-.018-1.529-.018-3.05-.018-4.57-.05-27.93.88-54.382,6.683-77.894a20.743,20.743,0,0,1,9.978-13.1l6.716-3.768Z",
    transform: "translate(-291.594 -274.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    className: "cls-6",
    d: "M369.7,373.064c0,1.522-.007,3.043-.007,4.572-.052,12.807-.259,25.889-.282,39.075-7.108,4.541-18.684,4.475-28.108,3.9,2.589-24.584,1.343-59.92.215-98.691-.46-15.4-.9-31.329-1.076-47.357l5.817,3.273,6.694,3.754a20.7,20.7,0,0,1,7.584,7.346,20.979,20.979,0,0,1,2.389,5.751,190.788,190.788,0,0,1,3.725,19.768,341.356,341.356,0,0,1,2.805,37.376c.045,1.848.089,3.7.119,5.566C369.675,362.565,369.7,367.788,369.7,373.064Z",
    transform: "translate(-284.755 -274.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    className: "cls-11",
    d: "M367.82,358.446c0,1.521-.009,3.041-.009,4.57H351.285c-.016-1.529-.016-3.05-.016-4.57Z",
    transform: "translate(-282.869 -259.801)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(7.793 84.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    className: "cls-12",
    d: "M317.192,359.329v3.778h-2.219l-.8-1.448a.129.129,0,0,1-.022-.036l-.5-.921a1.845,1.845,0,0,1,.275-2.167,1.728,1.728,0,0,1,.46-.364l.029-.021a1.866,1.866,0,0,1,2.285.385,1.7,1.7,0,0,1,.237.326l.134.245Z",
    transform: "translate(-297.26 -344.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    className: "cls-12",
    d: "M315.462,362.837h-4.3l-.067-.112c-.007-.015-.014-.038-.022-.052l-.237-.424a1.864,1.864,0,0,1,.735-2.529l.036-.022a1.859,1.859,0,0,1,2.531.734l.5.921a.128.128,0,0,0,.022.036Z",
    transform: "translate(-297.75 -343.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    className: "cls-12",
    d: "M306.943,351.394l.018-.038a1.962,1.962,0,0,1,2.783-.755,61.406,61.406,0,0,0,12.2,4.987,2.092,2.092,0,0,1,1.431,2.492l-.009.039a1.95,1.95,0,0,1-2.485,1.41,65.371,65.371,0,0,1-12.828-5.152A2.363,2.363,0,0,1,306.943,351.394Z",
    transform: "translate(-298.421 -345.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    className: "cls-12",
    d: "M311.643,362.568h-3.821a1.863,1.863,0,0,1,.935-1.306l.029-.015a1.857,1.857,0,0,1,2.531.734l.237.424c.008.014.015.036.022.052Z",
    transform: "translate(-298.235 -343.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    className: "cls-13",
    d: "M317.6,357.672l-.474.268-3.309,1.818-8.289,4.572h-.986l-.1-.186-1.833-3.333a5.19,5.19,0,0,1-.438-1.053,5.4,5.4,0,0,1,.23-3.814c.074-.163.156-.326.245-.483a5.38,5.38,0,0,1,2.115-2.1l2.856-1.572h.008l.356-.2a5.431,5.431,0,0,1,3.436-.624h.007c.022,0,.045.007.06.007h.007c.141.022.282.053.423.089a5.364,5.364,0,0,1,2.426,1.3l.008.007a5.406,5.406,0,0,1,1.083,1.381l.045.081,1.8,3.25Z",
    transform: "translate(-299.261 -345.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    className: "cls-13",
    d: "M313.489,354.824l-2.285,1.261-6.738,3.71-.156-.282-1.506-2.731-.334-.609-1.313-2.389-1.5-2.723,9.016-4.972,1.373,2.486,1.759,3.191.015.037h.007Z",
    transform: "translate(-299.658 -346.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    className: "cls-13",
    d: "M318.82,359.635v2.627a1.845,1.845,0,0,1-.476.378l-.036.015a1.864,1.864,0,0,1-2.508-.69,1.833,1.833,0,0,1,.1,1.448H312.3l-.089-.163c.008.014.015.036.022.052a.75.75,0,0,1,.053.112h-8.111l-.1-.186.712-.393,7.25-3.993,3.881-2.137.986-.541.327.593.3.543.854,1.543.177.326.134.245Z",
    transform: "translate(-298.888 -344.335)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    className: "cls-6",
    d: "M319.655,293.954c-.1.141-.208.289-.3.43-9.736,13.624-15.153,28.295-12.9,45.763,1.194,9.312,3.546,10.262,7.331,17.542l-2.575,1.505-8.889,5.209-2.062,1.2-.594.349c-.912-2.175-1.766-4.378-2.5-6.649a78.527,78.527,0,0,1-4.082-27.462,64.494,64.494,0,0,1,7.762-28.487,98.353,98.353,0,0,1,7.709-12.006c1.915-2.582,4.431-6.671,7.941-6.122C320.2,285.806,321.97,290.741,319.655,293.954Z",
    transform: "translate(-293.021 -272.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    className: "cls-11",
    d: "M319.281,358.444v4.572H301.442c-.015-1.529-.015-3.05-.015-4.572Z",
    transform: "translate(-291.556 -259.802)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(78.451 27.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    className: "cls-8",
    d: "M360.885,346.51l27.984,1.859a1.843,1.843,0,0,0,1.723-1.542l9.818-45.045c.2-.9-.256-1.673-1.011-1.724L371.415,298.2a1.842,1.842,0,0,0-1.723,1.542l-9.818,45.045C359.677,345.689,360.13,346.461,360.885,346.51Z",
    transform: "translate(-359.828 -298.198)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    className: "cls-13",
    d: "M386.646,320.576l.009-.042a2.389,2.389,0,0,1,2.234-2l3.885.252c.978.066,1.565,1.065,1.311,2.235l-.009.042a2.389,2.389,0,0,1-2.234,2l-3.883-.252C386.978,322.745,386.391,321.745,386.646,320.576Z",
    transform: "translate(-355.164 -294.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    className: "cls-13",
    d: "M385.846,324.226l.009-.042a2.389,2.389,0,0,1,2.234-2l4.67.307c.979.065,1.565,1.065,1.311,2.235l-.009.042a2.388,2.388,0,0,1-2.232,2l-4.67-.306C386.178,326.4,385.591,325.4,385.846,324.226Z",
    transform: "translate(-355.303 -294.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    className: "cls-13",
    d: "M385.046,327.876l.009-.042a2.39,2.39,0,0,1,2.233-2l4.5.295c.979.066,1.565,1.065,1.31,2.235l-.009.042a2.388,2.388,0,0,1-2.232,2l-4.5-.295C385.378,330.047,384.791,329.046,385.046,327.876Z",
    transform: "translate(-355.442 -293.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    className: "cls-13",
    d: "M384.646,331.31l.008-.039a2.12,2.12,0,0,1,1.982-1.773l3.448.224c.869.058,1.389.945,1.164,1.983l-.008.038a2.122,2.122,0,0,1-1.982,1.774l-3.448-.225C384.941,333.235,384.419,332.347,384.646,331.31Z",
    transform: "translate(-355.511 -292.743)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(17.206 28.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    className: "cls-7",
    d: "M318.518,332.669a3.448,3.448,0,0,1-2.864-1.318,12.748,12.748,0,0,1-2.14-4.545l-4.434-13.921c-.746-2.338-1.673-5.247-1.334-8.07a6.559,6.559,0,0,1,2.067-4.139,2.9,2.9,0,0,1,2.721-.682l-.137.951a2.3,2.3,0,0,0-2.127.551,5.561,5.561,0,0,0-1.751,3.511c-.308,2.561.539,5.215,1.285,7.557l4.434,13.921a11.971,11.971,0,0,0,1.929,4.164,2.425,2.425,0,0,0,2.818.871l.115-.063.127.036a2.417,2.417,0,0,0,2.561-1.462,11.952,11.952,0,0,0,.981-4.482L324.078,311c.22-2.448.47-5.222-.386-7.655a5.562,5.562,0,0,0-2.471-3.048,2.3,2.3,0,0,0-2.2-.075l-.339-.9a2.893,2.893,0,0,1,2.8.075,6.557,6.557,0,0,1,2.916,3.592c.943,2.682.669,5.724.449,8.167l-1.309,14.553a12.734,12.734,0,0,1-1.1,4.9,3.127,3.127,0,0,1-3.23,1.871A2.152,2.152,0,0,1,318.518,332.669Z",
    transform: "translate(-307.674 -298.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    className: "cls-9",
    d: "M313.459,301.16l-1.875.059a.5.5,0,0,1-.456-.488l-.083-.761a.5.5,0,0,1,.339-.577l1.844-.35c.242-.046.474.175.508.483l.115,1.053A.481.481,0,0,1,313.459,301.16Z",
    transform: "translate(-307.087 -298.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    className: "cls-9",
    d: "M316.1,300.849l1.844-.351a.5.5,0,0,0,.339-.575l-.083-.761a.5.5,0,0,0-.456-.489l-1.875.059a.481.481,0,0,0-.392.581l.115,1.053C315.628,300.674,315.86,300.895,316.1,300.849Z",
    transform: "translate(-306.314 -298.673)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    className: "cls-7",
    d: "M321.2,326.591c-1.287-1.132-1.212-2.736-1.14-4.286.018-.369.035-.739.033-1.1-.006-.97-.042-1.918-.079-2.866-.032-.83-.063-1.66-.075-2.509-.027-1.891-.476-4.258-1.655-5.236a3.136,3.136,0,0,0-2.6-.37,2.586,2.586,0,0,0-1.838,1.24,5.857,5.857,0,0,0-.336,3l.822,7.911-1.107.115-.822-7.911a6.928,6.928,0,0,1,.424-3.562,3.628,3.628,0,0,1,2.6-1.875,4.193,4.193,0,0,1,3.57.6c1.851,1.535,2.042,5.04,2.056,6.078.012.838.045,1.66.075,2.481.038.962.074,1.921.08,2.9,0,.384-.015.774-.034,1.16-.066,1.407-.122,2.621.763,3.4Z",
    transform: "translate(-289.654 -268.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    className: "cls-7",
    d: "M318.173,323.428a31.46,31.46,0,0,1-.24-3.341c-.035-.977-.072-1.988-.195-2.989-.023-.187-.042-.389-.062-.6a7.067,7.067,0,0,0-.258-1.568c-.145-.4-.588-.779-.941-.668-1.255.364-.817,3.829-.451,5.864l-1.1.2c-1.028-5.706.086-6.8,1.17-7.11a1.98,1.98,0,0,1,2.365,1.342,7.877,7.877,0,0,1,.319,1.839c.019.195.036.385.058.561.13,1.05.168,2.084.2,3.086a30.65,30.65,0,0,0,.229,3.226Z",
    transform: "translate(-289.273 -267.698)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(19.933 50.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    className: "cls-8",
    d: "M310,317.417v14.274A4.708,4.708,0,0,0,314.7,336.4h5.354a4.708,4.708,0,0,0,4.708-4.708V317.417Z",
    transform: "translate(-309.996 -317.417)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    className: "cls-11",
    width: 14.77,
    height: 3.586,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    className: "cls-7",
    d: "M313.689,330.182l-1.1-.143a15.076,15.076,0,0,0-.625-6.616c-.081-.245-.168-.491-.255-.735a11.044,11.044,0,0,1-.647-2.351,5.576,5.576,0,0,1,.73-3.811,2.188,2.188,0,0,1,2.49-.586,1.969,1.969,0,0,1,1.478,1.738h-1.113c0-.248-.314-.542-.729-.686a1.127,1.127,0,0,0-1.252.223,4.577,4.577,0,0,0-.5,2.983,10.258,10.258,0,0,0,.591,2.116c.09.252.181.506.265.761A16.215,16.215,0,0,1,313.689,330.182Z",
    transform: "translate(-289.887 -267.237)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(18.98 62.085)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    className: "cls-9",
    width: 2.229,
    height: 3.064,
    transform: "translate(3.337)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(0 2.161)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-7",
    cx: 4.452,
    cy: 4.452,
    r: 4.452
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    className: "cls-9",
    d: "M315.39,333.257a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,315.39,333.257Z",
    transform: "translate(-308.835 -328.805)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(20.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    className: "cls-13",
    d: "M334.878,287.385h0a8.72,8.72,0,0,1-8.7-8.695v-9.5a8.721,8.721,0,0,1,8.7-8.694h0a8.72,8.72,0,0,1,8.695,8.694v9.5A8.72,8.72,0,0,1,334.878,287.385Z",
    transform: "translate(-307.999 -210.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    className: "cls-12",
    d: "M334.878,260.5c4.782,0,8.241,4.917,7.748,10.274l-.823,8.941a7.183,7.183,0,0,1-6.925,6.665h0a7.183,7.183,0,0,1-6.926-6.665l-.823-8.941c-.493-5.357,2.966-10.274,7.749-10.274a8.721,8.721,0,0,0-8.7,8.694v9.5a8.72,8.72,0,0,0,8.7,8.695h0a8.72,8.72,0,0,0,8.695-8.695v-9.5A8.72,8.72,0,0,0,334.878,260.5Z",
    transform: "translate(-307.999 -210.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    className: "cls-12",
    d: "M340,278.834a18.153,18.153,0,0,0,3.512-.353,8.626,8.626,0,0,0,.059-.975V268c0-.235-.018-.467-.035-.7a13.267,13.267,0,0,1-4.306.73H330.59a13.241,13.241,0,0,1-4.372-.746c-.02.236-.036.472-.036.713v9.5a8.729,8.729,0,0,0,.058.966,18.134,18.134,0,0,0,3.585.362Z",
    transform: "translate(-307.999 -209.587)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(0 34.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    className: "cls-13",
    d: "M320.078,249.642s-4.332-4.239-7.793-1.473c-4.088,3.267.188,15.028,7.439,13.783Z",
    transform: "translate(-310.698 -247.232)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(42.489 34.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    className: "cls-13",
    d: "M346.88,249.642s4.332-4.239,7.793-1.473c4.088,3.267-.188,15.028-7.439,13.783Z",
    transform: "translate(-346.88 -247.232)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    className: "cls-13",
    d: "M336.1,280.94c-14.97,0-19.591-17.78-20.968-30.8a20.541,20.541,0,0,1,20.117-22.718l.484,0q.3,0,.6,0a20.559,20.559,0,0,1,20.177,22.327C355.362,262.94,351.06,280.94,336.1,280.94Z",
    transform: "translate(-309.945 -216.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    className: "cls-14",
    d: "M355.7,219.782c7.594,5.194.724,15.323.724,15.323s7.56,7.4-.222,24.828l-1.387-.283a45.834,45.834,0,0,0,0-13.441c-1.052-3.186-6.643-4.884-6.356-8.327,0,0-17.134,5.357-26.408.1a16.165,16.165,0,0,1-3.273,7.2c-2.127,2.329-.916,10.441-.642,13.95l-1.423.14c-.844-3.575-2.9-10.012-3.125-11.909-.14-1.2-.648-5.937-.867-9.327a16.694,16.694,0,0,1,1.685-8.617,11.287,11.287,0,0,1,3.2-4C322.59,221.7,348.815,215.071,355.7,219.782Z",
    transform: "translate(-310.351 -218.152)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(17.58 46.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    className: "cls-7",
    d: "M344.086,258.112a9.765,9.765,0,0,1-.7,1.612,10.86,10.86,0,0,1-3.443,3.933c-.205.137-.418.268-.64.39a9.124,9.124,0,0,1-4.515,1.129,9.652,9.652,0,0,1-4.155-.88c-.2-.092-.391-.193-.575-.3a9.7,9.7,0,0,1-3.55-3.556,9.055,9.055,0,0,1-.838-1.807c.015.008.27.159.73.377a19.379,19.379,0,0,0,8.221,1.76h.167l.185,0a19.328,19.328,0,0,0,8.235-2.156C343.749,258.33,344.059,258.13,344.086,258.112Z",
    transform: "translate(-325.668 -258.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    className: "cls-14",
    d: "M338.565,263.275a9.124,9.124,0,0,1-4.515,1.129,9.651,9.651,0,0,1-4.155-.88,9.084,9.084,0,0,1,4.445-.985A11.85,11.85,0,0,1,338.565,263.275Z",
    transform: "translate(-324.931 -257.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    className: "cls-5",
    d: "M344.086,258.112a9.765,9.765,0,0,1-.7,1.612,15.437,15.437,0,0,1-8.308,2.264,22.432,22.432,0,0,1-8.57-1.544,9.055,9.055,0,0,1-.838-1.807c.015.008.27.159.73.377a19.379,19.379,0,0,0,8.221,1.76h.167l.185,0a19.328,19.328,0,0,0,8.235-2.156C343.749,258.33,344.059,258.13,344.086,258.112Z",
    transform: "translate(-325.668 -258.112)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(11.759 26.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    className: "cls-14",
    d: "M320.711,245.387s1.151-3.064,3.82-4.055a7.026,7.026,0,0,1,5.3-.023.911.911,0,0,1,.514,1.078h0a.916.916,0,0,1-1.193.626C327.548,242.443,324.085,241.84,320.711,245.387Z",
    transform: "translate(-320.711 -240.808)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(31.422 26.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    className: "cls-14",
    d: "M347.257,245.165s-1.287-3.01-4-3.879a7.025,7.025,0,0,0-5.293.214.912.912,0,0,0-.466,1.1h0a.917.917,0,0,0,1.22.572C340.294,242.53,343.728,241.774,347.257,245.165Z",
    transform: "translate(-337.456 -240.88)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(22.232 55.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    className: "cls-12",
    d: "M334.245,267.172a8.015,8.015,0,0,1-4.347-1.148.551.551,0,0,1,.564-.947,7.534,7.534,0,0,0,7.39.014.551.551,0,0,1,.568.944A9.179,9.179,0,0,1,334.245,267.172Z",
    transform: "translate(-329.629 -265)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    className: "cls-5",
    d: "M338.093,250.436s3.984,5.453,9.183-.214c.173-.19-.248-1.013-.323-1.2a4.567,4.567,0,0,0-4.182-2.623,5.6,5.6,0,0,0-4.226,1.974A2.749,2.749,0,0,0,338.093,250.436Z",
    transform: "translate(-305.926 -213.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    className: "cls-7",
    d: "M345.375,249.546a3.077,3.077,0,1,1-3.077-3.077A3.077,3.077,0,0,1,345.375,249.546Z",
    transform: "translate(-305.726 -213.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    className: "cls-7",
    d: "M338.09,250.753a6.083,6.083,0,0,1,.853-3.482,3.4,3.4,0,0,1,1.521-1.194,5.169,5.169,0,0,1,1.871-.324,5.085,5.085,0,0,1,3.431,1.367,5.4,5.4,0,0,1,1.656,3.158,7.215,7.215,0,0,0-2.114-2.609,5.066,5.066,0,0,0-2.986-1.008,3.545,3.545,0,0,0-2.825,1.045A8.519,8.519,0,0,0,338.09,250.753Z",
    transform: "translate(-305.923 -213.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    className: "cls-5",
    d: "M330.147,250.436s-3.984,5.453-9.183-.214c-.173-.19.248-1.013.323-1.2a4.566,4.566,0,0,1,4.182-2.623,5.6,5.6,0,0,1,4.226,1.974A2.749,2.749,0,0,1,330.147,250.436Z",
    transform: "translate(-308.915 -213.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    className: "cls-7",
    d: "M322.406,249.546a3.077,3.077,0,1,0,3.077-3.077A3.077,3.077,0,0,0,322.406,249.546Z",
    transform: "translate(-308.657 -213.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    className: "cls-7",
    d: "M330.163,250.753a8.518,8.518,0,0,0-1.406-3.047,3.546,3.546,0,0,0-2.827-1.045,5.065,5.065,0,0,0-2.985,1.008,7.2,7.2,0,0,0-2.114,2.609,5.4,5.4,0,0,1,1.656-3.158,5.085,5.085,0,0,1,3.431-1.367,5.173,5.173,0,0,1,1.871.324,3.4,3.4,0,0,1,1.521,1.194A6.092,6.092,0,0,1,330.163,250.753Z",
    transform: "translate(-308.931 -213.341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    className: "cls-12",
    d: "M337.118,254.191a2.113,2.113,0,0,1-2.067,1.711h-1.9a2.113,2.113,0,0,1-2.067-1.711h-.455a2.617,2.617,0,0,0,2.6,2.439h1.737a2.617,2.617,0,0,0,2.6-2.439Z",
    transform: "translate(-307.223 -211.87)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(21.718 8.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    className: "cls-5",
    d: "M329.294,230.861a18.047,18.047,0,0,0,9.588.516A11.072,11.072,0,0,0,346.439,226c.076-.153-.149-.323-.256-.175a12.756,12.756,0,0,1-7.525,5.1,18.177,18.177,0,0,1-9.305-.332c-.173-.052-.227.217-.059.271Z",
    transform: "translate(-329.192 -225.764)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(0 17.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    className: "cls-11",
    d: "M250.876,233.859c2.49-.754,4.478-.7,8.406,2.61,5.608,4.731,7.415,11.449,8.151,19.217a72.155,72.155,0,0,1-.15,10.371c-.249,4.387-.564,8.824,2.042,12.61a43.047,43.047,0,0,1,3.032,5.68,9.861,9.861,0,0,1,.385,7.423,8.775,8.775,0,0,1-4.877,5.207,11.14,11.14,0,0,0-.464-3.488,3.316,3.316,0,0,0-2.3-2.275,4.662,4.662,0,0,1-1.549,4.664,7.373,7.373,0,0,0-2.205-4.508,10.891,10.891,0,0,1-2.063,3.913c-1.491,1.409-3.265,1.549-5.17,2.124a8.935,8.935,0,0,0,1.3-4.848,8.655,8.655,0,0,1-5.181,4.489,13.636,13.636,0,0,0,.878-3.929,11.4,11.4,0,0,1-7.952,4.082",
    transform: "translate(-152.032 -229.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    className: "cls-11",
    d: "M259.783,238.428c-4.59-8.689-11.657-8.818-18.377-7.7a28.709,28.709,0,0,0-13.661,6.339c-5.608,4.732-8.577,12.2-9.676,19.661a49.011,49.011,0,0,0-.44,9.9c.249,4.387,1.113,9.423-1.493,13.209-1.178,1.712-2.672,3.186-3.582,5.081a9.861,9.861,0,0,0-.385,7.423,8.772,8.772,0,0,0,4.877,5.207,11.14,11.14,0,0,1,.463-3.488,3.319,3.319,0,0,1,2.3-2.275,4.664,4.664,0,0,0,1.548,4.664,7.376,7.376,0,0,1,2.208-4.509c-.541.511,1.249,3.265,1.533,3.593,1.214,1.412,2.922,1.517,4.637,1.993-.233-1.308-.37-2.917.6-3.727a8.475,8.475,0,0,0,5.091,3.929,3.223,3.223,0,0,1,.727-3.84,10.254,10.254,0,0,0,2.549,2.679,4.256,4.256,0,0,0,3.409.713",
    transform: "translate(-157.528 -230.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    className: "cls-7",
    d: "M216.564,347.363a2.071,2.071,0,0,0-.507.343c-.082-.154-.163-.31-.238-.473l-9.763-21.152c-1-2.158-.9-4.347.223-4.864s2.851.827,3.847,2.985l9.763,21.152c.061.132.117.264.17.4Z",
    transform: "translate(-158.618 -214.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    className: "cls-10",
    d: "M221.635,341.436l-9.251,4.27,33.962,71.868,9.826,9.131-.575-13.4Z",
    transform: "translate(-157.395 -210.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    className: "cls-9",
    d: "M217.173,342.964l-1.48.683,33.962,71.868,5.94,10.924-4.46-11.608Z",
    transform: "translate(-156.818 -210.587)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    className: "cls-7",
    width: 14.673,
    height: 3.23,
    rx: 0.902,
    transform: "translate(51.877 133.46) rotate(-24.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    className: "cls-7",
    d: "M205.621,319.379h0a4.006,4.006,0,0,0-1.953,5.3h0a4.006,4.006,0,0,0,5.3,1.953h0a4.006,4.006,0,0,0,1.953-5.3h0A4.005,4.005,0,0,0,205.621,319.379Z",
    transform: "translate(-158.978 -214.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    className: "cls-6",
    d: "M241.627,375.254c0,20.9-4.682,28.39-10.458,28.39s-10.458-7.489-10.458-28.39,4.683-37.843,10.458-37.843S241.627,354.354,241.627,375.254Z",
    transform: "translate(-155.944 -211.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    className: "cls-6",
    d: "M239.079,410.875c-1.032,23.635-5.32,36.044-6.913,36.044-1.857,0-9.04-18.017-9.04-38.918,0-13.2,1.846-19.872,7.621-19.872S239.99,389.995,239.079,410.875Z",
    transform: "translate(-155.523 -202.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    className: "cls-9",
    d: "M238.434,393.191l-16.007,2.085v-8.5l16.007,2.085Z",
    transform: "translate(-155.645 -202.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-10",
    cx: 7.758,
    cy: 10.569,
    rx: 7.758,
    ry: 10.569,
    transform: "translate(60.841 177.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    className: "cls-9",
    d: "M224.248,381.4a5.8,5.8,0,0,0-1.852.316c3.388,1.133,5.9,5.287,5.9,10.253s-2.517,9.12-5.9,10.253a5.829,5.829,0,0,0,1.852.316c4.285,0,7.759-4.732,7.759-10.569S228.533,381.4,224.248,381.4Z",
    transform: "translate(-155.65 -203.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    className: "cls-9",
    d: "M223.37,418.173l15.612-5.011.319,36.13-3.868,1.891s3.4-10.052-9.977-12.888Z",
    transform: "translate(-155.48 -198.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    className: "cls-10",
    d: "M237.965,447.452s4.677-11.7-9.977-12.888c-11.826,10.18-19.14,15.522-19.14,15.522S210.083,457.837,237.965,447.452Z",
    transform: "translate(-158.011 -194.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    className: "cls-6",
    d: "M209.748,447.879c-.588.444-.9.671-.9.671s1.235,7.752,29.117-2.634a11.7,11.7,0,0,0,.608-2.534C220.477,449.958,212.808,449.12,209.748,447.879Z",
    transform: "translate(-158.011 -193.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    className: "cls-10",
    d: "M238.982,413.162l-15.612,5.011.656,6.328,15.019-4.21Z",
    transform: "translate(-155.48 -198.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    className: "cls-6",
    d: "M242.894,375.254c0,20.9,4.683,28.39,10.458,28.39s10.458-7.489,10.458-28.39-4.682-37.843-10.458-37.843S242.894,354.354,242.894,375.254Z",
    transform: "translate(-152.077 -211.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    className: "cls-6",
    d: "M244.727,410.875c1.031,23.635,5.318,36.044,6.913,36.044,1.857,0,9.04-18.017,9.04-38.918,0-13.2-1.846-19.872-7.622-19.872S243.816,389.995,244.727,410.875Z",
    transform: "translate(-151.783 -202.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    className: "cls-9",
    d: "M245.359,393.191l16.007,2.085v-8.5l-16.007,2.085Z",
    transform: "translate(-151.648 -202.95)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "cls-10",
    cx: 7.758,
    cy: 10.569,
    rx: 7.758,
    ry: 10.569,
    transform: "translate(100.144 177.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    className: "cls-9",
    d: "M258.594,381.4a5.8,5.8,0,0,1,1.853.316c-3.388,1.133-5.906,5.287-5.906,10.253s2.518,9.12,5.906,10.253a5.837,5.837,0,0,1-1.853.316c-4.284,0-7.757-4.732-7.757-10.569S254.311,381.4,258.594,381.4Z",
    transform: "translate(-150.693 -203.888)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    className: "cls-9",
    d: "M260.412,418.173,244.8,413.162l-.319,36.13,3.868,1.891s-3.4-10.052,9.977-12.888Z",
    transform: "translate(-151.801 -198.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    className: "cls-10",
    d: "M247.879,447.452s-4.677-11.7,9.977-12.888c11.825,10.18,19.14,15.522,19.14,15.522S275.76,457.837,247.879,447.452Z",
    transform: "translate(-151.332 -194.621)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    className: "cls-6",
    d: "M276.082,447.879c.588.444.9.671.9.671s-1.237,7.752-29.117-2.634a11.74,11.74,0,0,1-.609-2.534C265.351,449.958,273.02,449.12,276.082,447.879Z",
    transform: "translate(-151.317 -193.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    className: "cls-10",
    d: "M244.761,413.162l15.613,5.011-.656,6.328L244.7,420.29Z",
    transform: "translate(-151.763 -198.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    className: "cls-9",
    d: "M252.038,344.264H235.277c-5.753,0-10.889-1.987-11.482-4.547a14.726,14.726,0,0,0,.349,3.468l14.216,39.749s1.62,1.612,3.121,1.612h4.353c1.5,0,3.121-1.612,3.121-1.612l14.215-39.749a14.666,14.666,0,0,0,.35-3.468C262.927,342.277,257.79,344.264,252.038,344.264Z",
    transform: "translate(-155.407 -211.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    className: "cls-9",
    d: "M252.466,350.307H235.706c-5.779,0-10.937-2-11.493-4.58l-2.774-30.687c-.941-5.309,4.341-9.992,11.812-9.992h21.669c7.47,0,12.752,4.683,11.811,9.992l-2.773,30.687C263.4,348.3,258.244,350.307,252.466,350.307Z",
    transform: "translate(-155.836 -217.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    className: "cls-6",
    d: "M252.038,344.264H235.277c-5.753,0-10.889-1.987-11.482-4.547a14.726,14.726,0,0,0,.349,3.468l.26.789c1.622,1.978,6.024,3.39,10.874,3.39h16.761c4.85,0,9.251-1.413,10.873-3.39l.26-.789a14.666,14.666,0,0,0,.35-3.468C262.927,342.277,257.79,344.264,252.038,344.264Z",
    transform: "translate(-155.407 -211.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    className: "cls-10",
    d: "M272.186,303.529c0,16.248-12.271,29.419-27.409,29.419s-27.409-13.171-27.409-29.419,12.271-20.423,27.409-20.423S272.186,287.283,272.186,303.529Z",
    transform: "translate(-156.527 -221.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    className: "cls-9",
    d: "M190,308.941c-4.642-.322-8.6,2.178-8.834,5.586s3.335,6.432,7.977,6.753,8.6-2.178,8.834-5.586S194.641,309.264,190,308.941Z",
    transform: "translate(-162.839 -216.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    className: "cls-6",
    d: "M178.717,305.264c2.279,4.417,5.936,11.839,7.591,14.189,2.8,3.983,12.379-1.217,13.237-1.686,1.341-.734.053-3.4-4.425-10.593-7.459-11.977-15.187-27.721-19.357-25.436S172.572,293.356,178.717,305.264Z",
    transform: "translate(-164.219 -221.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    className: "cls-9",
    d: "M173.535,290.839l2.3,13.329,9.6-.895,5.05-5.533-7.621-13.47Z",
    transform: "translate(-164.166 -220.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    className: "cls-9",
    d: "M275.956,326.64c0,4.654,2.769,8.426,6.185,8.426s6.185-3.772,6.185-8.426-2.769-8.426-6.185-8.426S275.956,321.986,275.956,326.64Z",
    transform: "translate(-146.314 -214.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    className: "cls-6",
    d: "M284.069,344.261c.679-4.924,1.961-13.1,1.961-15.973,0-4.87-10.824-6.13-11.795-6.24-1.52-.17-2,2.754-2.48,11.21-.794,14.087-3.537,31.409,1.187,31.942S282.24,357.537,284.069,344.261Z",
    transform: "translate(-147.31 -214.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    className: "cls-9",
    d: "M280.447,355.713l5.793-12.222-8.369-4.8-7.314,1.617-1.522,15.4Z",
    transform: "translate(-147.521 -211.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    className: "cls-10",
    d: "M276.967,340.873l-6.809,1.506.2-2.068,7.314-1.617,8.369,4.8-.964,2.034Z",
    transform: "translate(-147.325 -211.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    className: "cls-6",
    d: "M267.412,312.622c1.311,3.584,5.57,18.681,7.553,19.937,1.771,1.123,10.131,1.868,11.327,0,1.537-2.4,1.389-12.574-2.49-27.125-4.466-16.755-9.258-22.154-13.92-21.047S261.462,296.335,267.412,312.622Z",
    transform: "translate(-148.338 -220.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    className: "cls-9",
    d: "M271.7,327.617l14.758,1.662V322.5L271.7,324.167Z",
    transform: "translate(-147.056 -214.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    className: "cls-9",
    d: "M264.49,359.079h0a1.7,1.7,0,0,1,.048-2.4l4.728-4.545a1.7,1.7,0,0,1,2.4.047h0a1.7,1.7,0,0,1-.047,2.4l-4.728,4.545A1.7,1.7,0,0,1,264.49,359.079Z",
    transform: "translate(-148.395 -209.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    className: "cls-9",
    d: "M268.511,362.585h0a1.7,1.7,0,0,1-2.3-.661l-2.094-3.78a1.7,1.7,0,0,1,.661-2.3h0a1.7,1.7,0,0,1,2.3.661l2.094,3.78A1.7,1.7,0,0,1,268.511,362.585Z",
    transform: "translate(-148.415 -208.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    className: "cls-10",
    d: "M275.754,369.293h0a1.7,1.7,0,0,0,2.052-1.24l1.441-5.843a1.7,1.7,0,0,0-1.24-2.052h0a1.7,1.7,0,0,0-2.052,1.24l-1.441,5.843A1.7,1.7,0,0,0,275.754,369.293Z",
    transform: "translate(-146.574 -207.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    className: "cls-10",
    d: "M272.453,369.018h0a1.7,1.7,0,0,0,2.052-1.24l1.051-4.26a1.7,1.7,0,0,0-1.24-2.051h0a1.7,1.7,0,0,0-2.051,1.239l-1.051,4.262A1.7,1.7,0,0,0,272.453,369.018Z",
    transform: "translate(-147.15 -207.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    className: "cls-10",
    d: "M266.134,367.621h0a1.7,1.7,0,0,1-1.239-2.051l1.57-6.367a1.7,1.7,0,0,1,2.051-1.239h0a1.7,1.7,0,0,1,1.239,2.052l-1.57,6.366A1.7,1.7,0,0,1,266.134,367.621Z",
    transform: "translate(-148.251 -207.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    className: "cls-10",
    d: "M269.075,368.807h0a1.7,1.7,0,0,1-1.24-2.051l1.051-4.26a1.7,1.7,0,0,1,2.052-1.24h0a1.7,1.7,0,0,1,1.24,2.051l-1.051,4.262A1.7,1.7,0,0,1,269.075,368.807Z",
    transform: "translate(-147.738 -207.408)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    className: "cls-10",
    width: 14.849,
    height: 14.316,
    rx: 3.079,
    transform: "matrix(-0.971, -0.239, 0.239, -0.971, 131.715, 158.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    className: "cls-10",
    d: "M184.478,299.352l4.7-5.151,1.023,1.809-5.05,5.533-9.6.895-.382-2.218Z",
    transform: "translate(-163.882 -219.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    className: "cls-6",
    d: "M202.492,294.319c-2.781,2.614-14.985,12.466-15.361,14.784-.336,2.069,2.265,10.048,4.453,10.415,2.814.47,12.108-3.667,23.962-12.955,13.649-10.694,16.73-17.223,13.878-21.074S215.128,282.443,202.492,294.319Z",
    transform: "translate(-161.802 -220.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    className: "cls-9",
    d: "M236.244,278.517s-28.508-8.111-35.25,14.559l27.247,9.418Z",
    transform: "translate(-159.38 -222.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    className: "cls-7",
    d: "M233.081,277.723l-7.039,21.089-24.16-8.35a26.549,26.549,0,0,0-.888,2.507l27.247,9.418,8-23.977S235.044,278.069,233.081,277.723Z",
    transform: "translate(-159.38 -221.959)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    className: "cls-6",
    cx: 4.638,
    cy: 4.638,
    r: 4.638,
    transform: "translate(64.224 75.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    className: "cls-7",
    d: "M227.611,299.167a2.973,2.973,0,1,1-2.973-2.972A2.974,2.974,0,0,1,227.611,299.167Z",
    transform: "translate(-155.777 -218.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    className: "cls-9",
    d: "M250.4,278.517s28.509-8.111,35.249,14.559l-27.247,9.418Z",
    transform: "translate(-150.768 -222.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    className: "cls-7",
    d: "M253.569,277.723l7.038,21.089,24.16-8.35a25.88,25.88,0,0,1,.888,2.507l-27.247,9.418-8-23.977S251.605,278.069,253.569,277.723Z",
    transform: "translate(-150.768 -221.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    className: "cls-6",
    d: "M253.27,299.414a4.638,4.638,0,1,0,4.637-4.637A4.638,4.638,0,0,0,253.27,299.414Z",
    transform: "translate(-150.269 -218.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    className: "cls-7",
    d: "M254.688,299.167a2.972,2.972,0,1,0,2.972-2.972A2.973,2.973,0,0,0,254.688,299.167Z",
    transform: "translate(-150.021 -218.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    className: "cls-9",
    d: "M191.092,300.3l-7.313,17.368,6.39,2.349,2.749-19.717Z",
    transform: "translate(-162.381 -218.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    className: "cls-9",
    d: "M184.548,278.133h0a1.7,1.7,0,0,1,.936,2.207l-2.457,6.079a1.7,1.7,0,0,1-2.207.936h0a1.7,1.7,0,0,1-.937-2.207l2.457-6.079A1.7,1.7,0,0,1,184.548,278.133Z",
    transform: "translate(-163.081 -221.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    className: "cls-9",
    d: "M184.926,274.045h0a1.7,1.7,0,0,1,1.34,1.987l-.824,4.242a1.7,1.7,0,0,1-1.988,1.34h0a1.7,1.7,0,0,1-1.34-1.988l.826-4.24A1.7,1.7,0,0,1,184.926,274.045Z",
    transform: "translate(-162.677 -222.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    className: "cls-10",
    d: "M166.636,272.953h0a1.7,1.7,0,0,0-.964,2.195l3.575,9.172a1.7,1.7,0,0,0,2.195.964h0a1.7,1.7,0,0,0,.964-2.195l-3.575-9.172A1.7,1.7,0,0,0,166.636,272.953Z",
    transform: "translate(-165.557 -222.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    className: "cls-10",
    d: "M168.939,270.012h0a1.7,1.7,0,0,0-.963,2.195l3.474,8.915a1.7,1.7,0,0,0,2.195.964h0a1.7,1.7,0,0,0,.964-2.195l-3.475-8.915A1.7,1.7,0,0,0,168.939,270.012Z",
    transform: "translate(-165.156 -223.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    className: "cls-10",
    d: "M175.319,268.375h0c.868-.339,1.976.41,2.464,1.664l3.427,8.823c.487,1.254.175,2.558-.693,2.9h0c-.868.338-1.978-.411-2.464-1.665l-3.427-8.821C174.139,270.017,174.45,268.713,175.319,268.375Z",
    transform: "translate(-164.016 -223.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    className: "cls-10",
    d: "M171.7,267.921h0a1.7,1.7,0,0,1,2.194.964l3.62,9.29a1.7,1.7,0,0,1-.964,2.195h0a1.7,1.7,0,0,1-2.195-.964l-3.619-9.29A1.7,1.7,0,0,1,171.7,267.921Z",
    transform: "translate(-164.675 -223.687)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    className: "cls-10",
    width: 14.849,
    height: 14.316,
    rx: 3.079,
    transform: "translate(2.238 57.786) rotate(-21.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    className: "cls-7",
    d: "M245.056,368.476c-1.468-.787-1.577-3.308-.242-4.858a64.555,64.555,0,0,0,15-50.9c-.281-2.027,1.179-4.085,2.838-3.95a89.222,89.222,0,0,1,17.13,3.13c27.217,8.517,47.046,28.439,53.57,50.87a3.493,3.493,0,0,1-.9,1.163c-17.24,14.149-43.89,19.318-70.455,11.489A89.252,89.252,0,0,1,245.056,368.476Z",
    transform: "translate(-151.905 -216.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    className: "cls-11",
    d: "M252.151,363.831c-1.214-.647-1.313-2.7-.216-3.966a51.932,51.932,0,0,0,12.229-41.493c-.238-1.655.961-3.33,2.331-3.215a74.765,74.765,0,0,1,14.157,2.608c22.5,7.038,38.942,23.357,44.4,41.682a2.825,2.825,0,0,1-.739.945c-14.191,11.492-36.185,15.626-58.148,9.154A74.822,74.822,0,0,1,252.151,363.831Z",
    transform: "translate(-150.634 -215.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    className: "cls-6",
    d: "M262.52,320.759q2.635-2.624,5.267-5.251c-1.074-.14-2.148-.261-3.215-.351-1.37-.115-2.569,1.561-2.331,3.215C262.354,319.164,262.443,319.961,262.52,320.759Z",
    transform: "translate(-148.71 -215.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    className: "cls-6",
    d: "M283.077,318.087q-10,9.964-19.995,19.937c-.162.639-.319,1.279-.507,1.916a51.765,51.765,0,0,1-10.64,19.412,2.837,2.837,0,0,0-.147,3.691L292.63,322.2A76.132,76.132,0,0,0,283.077,318.087Z",
    transform: "translate(-150.634 -214.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    className: "cls-6",
    d: "M311.792,339.556q-14.349,14.382-28.714,28.752a68.511,68.511,0,0,0,7.625-.6l23.844-23.845C313.7,342.4,312.783,340.963,311.792,339.556Z",
    transform: "translate(-145.073 -211.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    className: "cls-6",
    d: "M301,326.947l-39.586,39.585c.981.334,1.965.661,2.97.958,2.438.718,4.873,1.285,7.3,1.746q18.159-18.162,36.3-36.343A68.523,68.523,0,0,0,301,326.947Z",
    transform: "translate(-148.849 -213.379)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    className: "cls-6",
    width: 19.03,
    height: 3.23,
    rx: 0.902,
    transform: "translate(55.673 139.898) rotate(-24.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    className: "cls-13",
    d: "M242.588,293.866h0a8.663,8.663,0,0,1-8.638-8.638V275.79a8.663,8.663,0,0,1,8.638-8.638h0a8.663,8.663,0,0,1,8.638,8.638v9.438A8.663,8.663,0,0,1,242.588,293.866Z",
    transform: "translate(-153.636 -223.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    className: "cls-12",
    d: "M242.588,267.152c4.751,0,8.188,4.885,7.7,10.206l-.817,8.882a7.136,7.136,0,0,1-6.88,6.622h0a7.135,7.135,0,0,1-6.88-6.622l-.819-8.882c-.49-5.321,2.947-10.206,7.7-10.206a8.663,8.663,0,0,0-8.638,8.638v9.438a8.663,8.663,0,0,0,8.638,8.638h0a8.663,8.663,0,0,0,8.638-8.638V275.79A8.663,8.663,0,0,0,242.588,267.152Z",
    transform: "translate(-153.636 -223.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    className: "cls-12",
    d: "M247.679,285.371a18.1,18.1,0,0,0,3.489-.351,8.79,8.79,0,0,0,.059-.969v-9.438c0-.234-.018-.464-.036-.694a13.151,13.151,0,0,1-4.277.726h-8.584a13.162,13.162,0,0,1-4.343-.741c-.02.235-.036.47-.036.709v9.438a8.645,8.645,0,0,0,.058.961,17.981,17.981,0,0,0,3.561.359Z",
    transform: "translate(-153.636 -222.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    className: "cls-13",
    d: "M253.989,260.383s2.708-2.418,5.415-.58,1.741,11.121-5.415,10.637",
    transform: "translate(-150.143 -225.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    className: "cls-13",
    d: "M228.357,260.385s-2.708-2.418-5.415-.58-1.742,11.121,5.415,10.637",
    transform: "translate(-155.797 -225.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    className: "cls-13",
    d: "M262.236,246.4c-3-12.764-18.469-10.733-18.469-10.733S228.3,233.641,225.3,246.4c0,0-1.985,16.115.336,24.044s12.511,16.763,18.134,16.763,15.813-8.834,18.134-16.763S262.236,246.4,262.236,246.4Z",
    transform: "translate(-155.282 -229.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    className: "cls-7",
    d: "M248.8,269.133c-.229-.251-3.054-.393-6.7-.393s-6.467.142-6.695.393c-.256.162,1.348,5.911,6.695,5.911S249.05,269.3,248.8,269.133Z",
    transform: "translate(-153.387 -223.525)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(82.906 43.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    className: "cls-14",
    d: "M247.772,272.7c-1.456,2.279-3.62,4.452-5.994,4.355-2.575-.1-4.473-2.16-5.621-4.129C238.166,271.165,243.485,269.169,247.772,272.7Z",
    transform: "translate(-236.157 -267.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    className: "cls-5",
    d: "M246.9,267.857c-.039,1.6-.4,1.6-.4,1.6-1.5.75-7.22,1.431-9.378,0-.228-.151-.269-.909-.311-1.423a.561.561,0,0,1,.337-.147C240.716,267.677,245.277,267.343,246.9,267.857Z",
    transform: "translate(-236.044 -267.585)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    className: "cls-11",
    d: "M258.513,236.29c1.744,1.807.04,5.5-.649,7.469a32.921,32.921,0,0,1-2.042,4.959,16.486,16.486,0,0,1-3.768,4.637,6.02,6.02,0,0,1-3.086,1.582.513.513,0,0,1-.413-.08.494.494,0,0,1-.117-.356,5,5,0,0,1,.872-2.519,14.734,14.734,0,0,1-5.441,3.107,35.964,35.964,0,0,0,4.321-5.374,25.9,25.9,0,0,1-16.629,6.456,2.622,2.622,0,0,1,.78-1.563l2.676-3.228q-2.366,1.383-4.651,2.9c-1.435.951-5.631,4.562-6.252,8.47-1.583-1.643-2.109-4.195-2.269-6.392a23.506,23.506,0,0,1,5.856-16.983,22.832,22.832,0,0,1,16.541-7.543C251.721,231.785,256.788,234.5,258.513,236.29Z",
    transform: "translate(-155.756 -229.958)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(93.821 26.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    className: "cls-7",
    d: "M257.233,256.805a7.657,7.657,0,0,0-2.841-2.394,11.745,11.745,0,0,0-3.382-1.382,9.1,9.1,0,0,0-3.034-.171c-.817.115-2.565.624-2.522,1.7a.214.214,0,0,0,.268.2c.447-.123.743-.564,1.144-.79a3.877,3.877,0,0,1,1.487-.444,8.855,8.855,0,0,1,2.708.175,13.287,13.287,0,0,1,6.041,3.209c.068.061.186-.018.133-.1Z",
    transform: "translate(-245.452 -252.794)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    className: "cls-7",
    d: "M245.825,261.695c-.47-.115.129-2.6,3.3-3.088a6.713,6.713,0,0,1,3.266.283,4.9,4.9,0,0,1,2.751,2.378,7.173,7.173,0,0,0-4.984-1.5C247.586,259.829,246.3,261.81,245.825,261.695Z",
    transform: "translate(-151.591 -225.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    className: "cls-7",
    d: "M253.071,258.834a1.4,1.4,0,0,1-.067.641,1.545,1.545,0,0,1-.372.58l-.224-.31a1.177,1.177,0,0,0,.427-.358A1.349,1.349,0,0,0,253.071,258.834Z",
    transform: "translate(-150.419 -225.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    className: "cls-7",
    d: "M253.855,258.913a1,1,0,0,1-.12.911,1.966,1.966,0,0,1-.7.685l-.155-.35a1.608,1.608,0,0,0,.7-.449A.918.918,0,0,0,253.855,258.913Z",
    transform: "translate(-150.337 -225.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    className: "cls-7",
    d: "M254.3,259.808a.677.677,0,0,1-.211.589,1.363,1.363,0,0,1-.575.357l-.141-.373a1.267,1.267,0,0,0,.6-.134A.6.6,0,0,0,254.3,259.808Z",
    transform: "translate(-150.252 -225.081)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(71.355 26.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    className: "cls-7",
    d: "M226.468,256.909a13.261,13.261,0,0,1,6.039-3.209,9.057,9.057,0,0,1,2.639-.182,3.972,3.972,0,0,1,1.495.417c.426.229.739.7,1.2.824a.215.215,0,0,0,.269-.2c.041-1.049-1.65-1.563-2.454-1.686a8.994,8.994,0,0,0-3.1.161,11.63,11.63,0,0,0-3.307,1.34,7.765,7.765,0,0,0-2.916,2.437c-.052.086.063.166.134.1Z",
    transform: "translate(-226.321 -252.794)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    className: "cls-7",
    d: "M237.4,261.695c.47-.115-.128-2.6-3.3-3.088a6.714,6.714,0,0,0-3.266.283,4.9,4.9,0,0,0-2.75,2.378,7.17,7.17,0,0,1,4.983-1.5C235.634,259.829,236.924,261.81,237.4,261.695Z",
    transform: "translate(-154.66 -225.305)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    className: "cls-7",
    d: "M228.846,258.834a1.386,1.386,0,0,0,.066.641,1.545,1.545,0,0,0,.372.58l.224-.31a1.177,1.177,0,0,1-.427-.358A1.357,1.357,0,0,1,228.846,258.834Z",
    transform: "translate(-154.528 -225.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    className: "cls-7",
    d: "M228.115,258.913a1,1,0,0,0,.12.911,1.967,1.967,0,0,0,.7.685l.155-.35a1.608,1.608,0,0,1-.7-.449A.918.918,0,0,1,228.115,258.913Z",
    transform: "translate(-154.663 -225.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    className: "cls-7",
    d: "M227.66,259.808a.68.68,0,0,0,.213.589,1.356,1.356,0,0,0,.574.357l.142-.373a1.271,1.271,0,0,1-.6-.134A.6.6,0,0,1,227.66,259.808Z",
    transform: "translate(-154.734 -225.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    className: "cls-11",
    d: "M251.382,243.688c-.73,3.941,1.577,11.769,2.76,11.628s.721-2.113,1.126-3.82c.54,3.742.425,5.57,1.685,9.135a6.126,6.126,0,0,0,1.611,2.77,22.641,22.641,0,0,0,2.554-10.559c.158-5.1.357-12.247-4.267-15.595-1.433-1.037-2.231-.875-3.973-.566",
    transform: "translate(-150.622 -229.153)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(107.013 10.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    className: "cls-15",
    d: "M256.715,239.258a30.273,30.273,0,0,1,3.066,10.12,39.013,39.013,0,0,1-.449,10.417.231.231,0,0,0,.445.123,23.527,23.527,0,0,0,.795-10.8,27.651,27.651,0,0,0-3.442-10.107c-.155-.27-.555-.032-.416.242Z",
    transform: "translate(-256.686 -238.897)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(63.807 7.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    className: "cls-15",
    d: "M229.017,236.786a25.664,25.664,0,0,0-7.986,11.055c-1.513,4.227-1.717,9.183.619,13.16.123.208.5.069.405-.171a18.116,18.116,0,0,1-.306-12.908,25.791,25.791,0,0,1,7.548-10.856c.195-.168-.085-.439-.279-.279Z",
    transform: "translate(-219.893 -236.738)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(78.538 1.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    className: "cls-15",
    d: "M232.577,234.565a24.378,24.378,0,0,1,9.9-2.035,22.085,22.085,0,0,1,5.049.7c1.646.425,3.145,1.2,4.762,1.684.214.063.419-.243.23-.393a12.47,12.47,0,0,0-4.677-1.967,22.345,22.345,0,0,0-5.241-.66,19.979,19.979,0,0,0-10.11,2.47c-.107.061-.034.257.087.207Z",
    transform: "translate(-232.438 -231.888)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(82.905 6.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    className: "cls-15",
    d: "M236.559,241.881a22.8,22.8,0,0,1,6.5-3.9,23.267,23.267,0,0,1,3.486-1.047c1.186-.257,2.394-.355,3.584-.584.235-.046.163-.385-.054-.4a17.572,17.572,0,0,0-7.467,1.671,23.948,23.948,0,0,0-6.379,3.935c-.225.194.1.518.326.326Z",
    transform: "translate(-236.156 -235.932)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(99.545 6.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    className: "cls-15",
    d: "M255.66,245.364a20.336,20.336,0,0,0-1.493-6.13c-.692-1.46-1.94-3.355-3.618-3.77a.175.175,0,0,0-.169.291c.622.564,1.314,1.02,1.885,1.649a9.191,9.191,0,0,1,1.444,2.183,21.592,21.592,0,0,1,1.6,5.825c.034.2.378.153.352-.048Z",
    transform: "translate(-250.326 -235.46)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    className: "cls-12",
    d: "M244.814,264.264a2.1,2.1,0,0,1-2.053,1.7h-1.887a2.1,2.1,0,0,1-2.053-1.7h-.452a2.6,2.6,0,0,0,2.586,2.424h1.726a2.6,2.6,0,0,0,2.585-2.424Z",
    transform: "translate(-152.866 -224.305)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileOpAvontuurMetAeroEnSol);
export default __webpack_public_path__ + "static/media/tile-op-avontuur-met-aero-en-sol.280d68e66a85f3cdccb7dae421caf47a.svg";
export { ForwardRef as ReactComponent };